import React, { useState, useContext, useEffect, useRef } from "react";
import axios from "axios";
import { LanguageContext } from "./LanguageContext";
import "./DataList.css";
import "./new_DataList.css";
import DataView from "./DataView";
import MuiAlert from "@mui/material/Alert";
import DatePicker from "react-datepicker";
import { IconButton } from "@mui/material";
import { CheckCircle as CheckCircleIcon } from "@mui/icons-material";
import "react-datepicker/dist/react-datepicker.css";
import "@fortawesome/fontawesome-svg-core/styles.css";
import { Edit as EditIcon } from "@mui/icons-material";
// import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import Navbar from "./Navbar";
import { IoPrintOutline } from "react-icons/io5";
import { FiEdit } from "react-icons/fi";
import { FiUpload } from "react-icons/fi";
import Pagination from "./Pagination";
import { AiOutlinePlus } from "react-icons/ai";
import { FcCalendar } from "react-icons/fc";
import _debounce from "lodash/debounce";
import { useLocation, useNavigate } from "react-router-dom";
import CustodyLog from "./CustodyLog";
import { CgArrowsScrollV } from "react-icons/cg";
import enTranslations from "./translations/en.json";
import guTranslations from "./translations/gu.json";
import hinTranslations from "./translations/hi.json";
import { MdAttachFile } from "react-icons/md";
import Tooltip from "@mui/material/Tooltip";
import { BsInfoCircle } from "react-icons/bs";
import Snackbar from "@mui/material/Snackbar";
import TextField from "@mui/material/TextField";
import mrTranslations from "./translations/mr.json";
import HierarchyFilterBar from "./components/report/HierarchyFilterBar";
import SearchableSelect from "./components/common/SearchableSelect";
import EntryTypeFields from "./components/common/EntryTypeFields";
import API_URL from "./Config";
import { IoMdClose } from "react-icons/io";
import { IoCloseOutline } from "react-icons/io5";
import { MdDeleteOutline } from "react-icons/md";
import { MdExpandMore } from "react-icons/md";
import Multiselect from "multiselect-react-dropdown";
import { getMasterDomainItems } from "./services/masterDataService";
import {
  buildEntryTypeValidationErrors,
  DEFAULT_ENTRY_TYPE_OPTIONS,
  getEntryTypeLabel,
  normalizeEntryTypeOptions,
  normalizeEntryTypeRecord,
  sanitizeRecordForEntryType,
} from "./utils/entryTypeHelpers";
import {
  buildActOptions,
  buildCasePropertyTypeOptions,
  buildStatusOptions,
  buildUnitOptions,
  buildVehicleReasonOptions,
  isOtherActOption,
  isOtherCasePropertyType,
  isVehicleCasePropertyType,
  matchActOptionsByNames,
  matchOptionValue,
} from "./utils/casePropertyMasterOptions";
import {
  ALL_DATES_FILTER_OPTION,
  exportCrimeData,
  normalizeDateFilterOption,
} from "./services/reportService";

const ensureArray = (value) => (Array.isArray(value) ? value : []);
const normalizeTextValue = (value, fallback = "NA") => {
  const nextValue = String(value ?? "").trim();
  return nextValue || fallback;
};
const VIEW_DATE_FILTER_OPTION_STORAGE_KEY = "viewDateFilterOption";
const DEFAULT_VIEW_DATE_FILTER_OPTION = "this_month";
const INITIAL_EXPORT_OPTIONS = {
  entryType: "",
  format: "xlsx",
  lang: "en",
  endDate: "",
  startDate: "",
  status: "",
};
const extractFilenameFromHeaders = (
  headers = {},
  fallback = "case-property-data.xlsx",
) => {
  const disposition =
    headers["content-disposition"] || headers["Content-Disposition"] || "";
  const match = disposition.match(/filename\*?=(?:UTF-8''|")?([^";\n]+)/i);

  if (!match?.[1]) {
    return fallback;
  }

  return decodeURIComponent(match[1]).replace(/^"(.*)"$/, "$1");
};
const getStoredUserState = () => {
  const storedState = String(localStorage.getItem("userState") ?? "").trim();
  const normalizedState = storedState.toLowerCase();

  return normalizedState === "null" || normalizedState === "undefined"
    ? ""
    : storedState;
};

function DataList() {
  const [data, setData] = useState([]);
  const [userState] = useState(getStoredUserState);

  useEffect(() => {
    document.body.classList.add("next-court-date-register-page");

    return () => {
      document.body.classList.remove("next-court-date-register-page");
    };
  }, []);
  const [sectionCfslName, setSectionCfslName] = useState("");
  const [sectionMemoNo, setSectionMemoNo] = useState("");
  const [sectionOtherStatus, setSectionOtherStatus] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [showCasePropertyPopup, setShowCasePropertyPopup] = useState(false);
  const [selectedData, setSelectedData] = useState("FSL Port Blair");
  const [showEditForm, setShowEditForm] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [srNoFilter, setSrNoFilter] = useState("");
  const [selectedDateOfHandingOver, setSelectedDateOfHandingOver] =
    useState("");
  const [selectedCourtOrderOption, setSelectedCourtOrderOption] =
    useState("Disposed");
  const [gunaNoFilter, setGunaNoFilter] = useState("");
  const [srNoSortOption, setSrNoSortOption] = useState("");
  const [srNoFilterApplied, setSrNoFilterApplied] = useState(false);
  const [gunaNoFilterApplied, setGunaNoFilterApplied] = useState(false);
  const [gunaNoSortOption, setGunaNoSortOption] = useState("");
  const [srNoFilterPopupOpen, setSrNoFilterPopupOpen] = useState("");
  const [gunaNoFilterPopupOpen, setGunaNoFilterPopupOpen] = useState("");
  const [loading, setLoading] = useState(true);
  const [filteredData, setFilteredData] = useState([]);
  const [sectionCourtOrderNo, setSectionCourtOrderNo] = useState("");
  const [showSectionOfLawInput, setShowSectionOfLawInput] = useState(false);
  const [sortOrder, setSortOrder] = useState("latest");
  const [isFormModified, setIsFormModified] = useState(false);
  const [, setDateRangeVisible] = useState(false);
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  const [selectedOption, setSelectedOption] = useState(
    normalizeDateFilterOption(
      localStorage.getItem(VIEW_DATE_FILTER_OPTION_STORAGE_KEY),
      DEFAULT_VIEW_DATE_FILTER_OPTION,
    ),
  );
  const [showPerPage, setShowPerPage] = useState(50);
  const [selectedAct, setSelectedAct] = useState("");
  const [attachmentFile, setAttachmentFile] = useState(null);
  const [isPopupOpens, setIsPopupOpen] = useState(false);
  const [sectionOfLaws, setSectionOfLaws] = useState({});
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedUnit, setSelectedUnit] = useState("");

  const [pagination, setPagination] = useState({
    start: 0,
    end: showPerPage,
  });
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [showInsertDataPopup, setShowInsertDataPopup] = useState(false);
  const [showSpecifyActInput, setShowSpecifyActInput] = useState(false);
  const [entryTypes, setEntryTypes] = useState(DEFAULT_ENTRY_TYPE_OPTIONS);
  const [editValidationErrors, setEditValidationErrors] = useState({});
  const [masterActOptions, setMasterActOptions] = useState([]);
  const [masterCasePropertyTypeOptions, setMasterCasePropertyTypeOptions] =
    useState([]);
  const [masterStatusOptions, setMasterStatusOptions] = useState([]);
  const [masterUnitOptions, setMasterUnitOptions] = useState([]);
  const [masterVehicleReasonOptions, setMasterVehicleReasonOptions] = useState(
    [],
  );
  const [sectionReleased, setSectionReleased] = useState("");
  const [sectionRelesedDate, setSectionRelesedDate] = useState("");
  const [sectionGdNo, setSectionGdNo] = useState("");
  const [sectionDate, setSectionDate] = useState("");
  const [sectionSentBy, setSectionSentBy] = useState("");
  const [sectionAuctionDate, setSectionAuctionDate] = useState("");
  const [sectionAawarded, setSectionAawarded] = useState("");
  const [sectionAuctionMemoNo, setSectionAuctionMemoNo] = useState("");
  const [sectionAuctionOrderNo, setSectionAuctionOrderNo] = useState("");
  const [sectionExecutiveOrderNo, setSectionExecutiveOrderNo] = useState("");
  const [selectedPaymentMode, setSelectedPaymentMode] = useState("");
  const [isPopupOpen, setPopupOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [remark, setRemark] = useState("");
  const [isRemarkSet, setIsRemarkSet] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [isExporting, setIsExporting] = useState(false);
  const [showExportPopup, setShowExportPopup] = useState(false);
  const [exportOptions, setExportOptions] = useState(INITIAL_EXPORT_OPTIONS);
  const [specifyAct, setSpecifyAct] = useState("");
  const [editingId, setEditingId] = useState(null);
  const [sectionDisposaldate, setSectionsectionDisposaldate] = useState("");

  const fileInputRef = useRef(null);

  const { selectedLanguage } = useContext(LanguageContext);
  const translations = {
    en: enTranslations,
    gu: guTranslations,
    hi: hinTranslations,
    mr: mrTranslations,
  };

  const translatedText = (key) => translations[selectedLanguage][key] || key;
  const activeCasePropertyTypeOptions = masterCasePropertyTypeOptions;
  const filteredOptions = masterActOptions;
  const otherActOption = selectedOptions.find((option) =>
    isOtherActOption(option),
  );
  const otherActOptionName = otherActOption?.name || "Others Acts";
  const getSectionOfLawValue = (optionName, { isOther = false } = {}) =>
    isOther
      ? sectionOfLaws[optionName] || sectionOfLaws["Others Acts"] || ""
      : sectionOfLaws[optionName] || "";

  const handleFileInputChange = (e, documentType) => {
    const files = e.target.files;
    const newFileDetails = Array.from(files).map((file) => ({
      name: file.name,
      size: file.size,
      type: documentType,
    }));

    setSelectedFiles([...selectedFiles, ...newFileDetails]);

    setAttachmentFile((prevFiles) => [
      ...(prevFiles || []),
      ...Array.from(files).map((file) => ({ file, type: documentType })),
    ]);
  };
  const handleSelect = (selectedList) => {
    const selectedLawNames = selectedList.map((law) => law.name).join(", ");
    setSelectedOptions(selectedList);
    setShowSpecifyActInput(
      selectedList.some((option) => isOtherActOption(option)),
    );
    setShowSectionOfLawInput(
      !selectedList.some((option) => isOtherActOption(option)),
    );
    setSelectedAct(selectedLawNames);
  };

  const closeUpdateButton = () => {
    setShowCasePropertyPopup(false);
  };
  const handleDisposalFileInputChange = (e) =>
    handleFileInputChange(e, "disposal");

  const handleDropdownCourtOrderChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedCourtOrderOption(selectedValue);
  };

  const handleUploadButtonClick = () => {
    // Trigger click event of file input when upload button is clicked
    fileInputRef.current.click();
  };
  const handleAuctionFileInputChange = (e) =>
    handleFileInputChange(e, "auction");
  const handleCourtOrderFileInputChange = (e) =>
    handleFileInputChange(e, "courtOrder");

  const countWords = (text) => {
    const words = normalizeTextValue(text).split(/\s+/);
    return words.length;
  };

  const handleUnitChange = (event) => {
    const nextUnit = event.target.value;
    setSelectedUnit(nextUnit);
    setSelectedData((prevData) =>
      prevData && typeof prevData === "object"
        ? {
            ...prevData,
            unit: nextUnit,
          }
        : prevData,
    );
  };

  const handleHandedOverFileInputChange = (e) =>
    handleFileInputChange(e, "handedOver");

  const handleDeleteFile = (indexToDelete) => {
    setSelectedFiles(
      selectedFiles.filter((_, index) => index !== indexToDelete),
    );
  };

  const handleCloseAttachment = () => {
    setIsPopupOpen(false);
  };

  const handleClosePopup = () => {
    setSelectedData(null);
    setShowPopup(false);
  };

  const handleEditClose = () => {
    setShowEditForm(false);
  };

  const loaderStyle = {
    width: "48px",
    height: "48px",
    border: "5px solid #14195d", // Blue color for loader
    borderBottomColor: "transparent",
    borderRadius: "50%",
    position: "absolute",
    top: "50%", // Center vertically
    left: "50%", // Center horizontally
    transform: "translate(-50%, -50%)", // Offset by half of the element's dimensions
    animation: "rotation 1s linear infinite", // Rotation animation
  };

  const containerStyle = {
    position: "fixed", // Fixed positioning to cover the entire screen
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };

  const keyframesStyle = `
    @keyframes rotation {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  `;

  const handleIconClick = () => {
    // Show selected files when icon is clicked
    setIsPopupOpen(true);
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    try {
      const authKey = localStorage.getItem("authKey");
      const nextEntryTypeErrors = buildEntryTypeValidationErrors(
        selectedData,
        entryTypes,
      );

      if (Object.values(nextEntryTypeErrors).some(Boolean)) {
        setEditValidationErrors(nextEntryTypeErrors);
        setSnackbarMessage("Please fill in all required fields.");
        setOpenSnackbar(true);
        return;
      }
      const hasOtherActSelected = selectedOptions.some((option) =>
        isOtherActOption(option),
      );

      // Construct sectionOfLawsObject
      const sectionOfLawsObject = {};
      for (const option of selectedOptions) {
        sectionOfLawsObject[option.name] = getSectionOfLawValue(option.name, {
          isOther: isOtherActOption(option),
        });
      }

      // Helper function to format date to 'YYYY-MM-DD'
      const formatDate = (date) => {
        if (!date) return null;
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      };

      // Include charge_sheet_date and next_court_date formatted as 'YYYY-MM-DD'
      const updatedData = {
        ...sanitizeRecordForEntryType(selectedData, entryTypes),
        act: hasOtherActSelected
          ? specifyAct.trim()
          : selectedOptions.map((option) => option.name).join(", "),
        specify_act: specifyAct,
        section_of_law: JSON.stringify(sectionOfLawsObject),
        unit: selectedUnit,
        chart_sheet_date: formatDate(selectedData.chart_sheet_date),
        next_court_date: formatDate(selectedData.next_court_date),
      };

      // API call to update the data
      await axios.put(`${API_URL}/api/data/${selectedData.id}`, updatedData, {
        headers: {
          Authorization: authKey,
        },
      });

      // Reset form states and fetch updated data
      setSelectedData(null);
      setShowEditForm(false);
      // fetchData();

      // Show success notification
      setSnackbarMessage("Data updated successfully!");
      setOpenSnackbar(true);
      setTimeout(() => {
        setOpenSnackbar(false);
      }, 1000);
    } catch (error) {
      console.error("Error updating main crime data:", error);
    }
  };

  const handleSectionOfLawChange = (e, optionName) => {
    setSectionOfLaws({
      ...sectionOfLaws,
      [optionName]: e.target.value,
    });
  };

  const handleRemove = (selectedList) => {
    const selectedLawNames = selectedList.map((law) => law.name).join(", ");
    setSelectedOptions(selectedList);
    setShowSpecifyActInput(
      selectedList.some((option) => isOtherActOption(option)),
    );
    setShowSectionOfLawInput(
      !selectedList.some((option) => isOtherActOption(option)),
    );
    setSelectedAct(selectedLawNames);
  };

  const clearEditValidationErrors = (...fields) => {
    setEditValidationErrors((prevErrors) => {
      const nextErrors = { ...prevErrors };
      fields.forEach((field) => {
        nextErrors[field] = false;
      });
      return nextErrors;
    });
  };

  const handleEntryTypeChange = (entryTypeCode) => {
    setSelectedData((prevData) =>
      sanitizeRecordForEntryType(
        {
          ...normalizeEntryTypeRecord(prevData, entryTypes),
          entry_type: entryTypeCode,
        },
        entryTypes,
      ),
    );
    clearEditValidationErrors(
      "entry_type",
      "guna_number",
      "receipt_number",
      "other_entry_type",
    );
  };

  const handleEntryTypeFieldChange = (fieldName, value) => {
    setSelectedData((prevData) => ({
      ...prevData,
      [fieldName]: value,
    }));
    clearEditValidationErrors(fieldName);
  };

  // const handleChange = async (event) => {
  //   const value = event.target.value;
  //   setSelectedOption(value);
  //   setIsFormModified(true);
  //   localStorage.setItem("selectedFilter", value);

  //   try {
  //     const authKey = localStorage.getItem("authKey");
  //     let url = `${API_URL}/api/user/v1/data/filtered_crime_data?filter_option=${value}`;

  //     // If custom date range is selected, add start and end dates to URL
  //     if (value === "custom") {
  //       setDateRangeVisible(true);
  //       if (selectedStartDate && selectedEndDate) {
  //         const formattedStartDate = selectedStartDate.toISOString().split('T')[0];
  //         const formattedEndDate = selectedEndDate.toISOString().split('T')[0];
  //         url = `${API_URL}/api/user/v1/data/filtered_crime_data?start_date=${formattedStartDate}&end_date=${formattedEndDate}`;
  //       }
  //     } else {
  //       setDateRangeVisible(false);
  //     }

  //     const response = await axios.get(url, {
  //       headers: {
  //         Authorization: authKey,
  //       },
  //     });

  //     if (response.data.success) {
  //       setData(response.data.data);
  //       setFilteredData(response.data.data);
  //     } else {
  //       setSnackbarMessage(response.data.message || "No data found");
  //       setOpenSnackbar(true);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching filtered data:", error);
  //     setSnackbarMessage("Error fetching data");
  //     setOpenSnackbar(true);
  //   }
  // };

  const formatDateForApi = (date) => {
    if (!date) {
      return "";
    }

    const nextDate = date instanceof Date ? date : new Date(date);

    if (Number.isNaN(nextDate.getTime())) {
      return "";
    }

    const day = String(nextDate.getDate()).padStart(2, "0");
    const month = String(nextDate.getMonth() + 1).padStart(2, "0");
    const year = nextDate.getFullYear();

    return `${year}-${month}-${day}`;
  };

  const fetchNextCourtDateData = async () => {
    const authKey = localStorage.getItem("authKey");
    const params = new URLSearchParams();
    const normalizedFilterOption =
      selectedOption === "custom"
        ? "custom"
        : normalizeDateFilterOption(selectedOption, ALL_DATES_FILTER_OPTION);

    if (normalizedFilterOption && normalizedFilterOption !== "custom") {
      params.set("filter_option", normalizedFilterOption);
    } else {
      const formattedStartDate = formatDateForApi(selectedStartDate);
      const formattedEndDate = formatDateForApi(selectedEndDate);

      if (formattedStartDate && formattedEndDate) {
        params.set("start_date", formattedStartDate);
        params.set("end_date", formattedEndDate);
      }
    }

    const url = `${API_URL}/api/user/v1/data/filtered_crime_data${
      params.toString() ? `?${params.toString()}` : ""
    }`;
    const response = await axios.get(url, {
      headers: {
        Authorization: authKey,
      },
    });

    return ensureArray(response?.data?.data);
  };

  const fetchData = async () => {
    setLoading(true);

    try {
      const apiData = await fetchNextCourtDateData();
      setData(apiData);
      setFilteredData(apiData);
    } catch (error) {
      console.error("Error fetching filtered data:", error);
      setSnackbarMessage("Error fetching data");
      setOpenSnackbar(true);
      setData([]);
      setFilteredData([]);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (event) => {
    const value =
      event.target.value === ""
        ? ALL_DATES_FILTER_OPTION
        : normalizeDateFilterOption(event.target.value);
    setSelectedOption(value);
    setIsFormModified(true);

    if (value === "custom") {
      setDateRangeVisible(true);
      return;
    }

    setDateRangeVisible(false);
    setSelectedStartDate(null);
    setSelectedEndDate(null);
  };

  const updateStatusDetails = async (e) => {
    e.preventDefault();
    try {
      const authKey = localStorage.getItem("authKey");
      const newStatusOfMuddamaal = selectedData.new_status_of_muddamaal;

      const statusDetailsData = {
        ...selectedData,
        new_status_of_muddamaal: newStatusOfMuddamaal,
        court_order_no: sectionCourtOrderNo,
        released_to_whom: sectionReleased,
        release_date: sectionRelesedDate,
        gd_no: sectionGdNo,
        date: sectionDate,
        cfslName: sectionCfslName,
        sentBy: sectionSentBy,
        other_status_case_property: sectionOtherStatus,
        auctionDate: sectionAuctionDate,
        executiveOrder: sectionExecutiveOrderNo,
        disposalDate: sectionDisposaldate,
        auctionOrderNo: sectionAuctionOrderNo,
        awarded: sectionAawarded,
        auctionMemoNo: sectionAuctionMemoNo,
        memoNo: sectionMemoNo,
        dateOfHandingOver: selectedDateOfHandingOver,
        paymentMode: selectedPaymentMode,
        disposalOnCourt: selectedCourtOrderOption,
      };

      // Create a FormData object
      const formData = new FormData();

      // Append the form fields to the FormData object
      Object.keys(statusDetailsData).forEach((key) => {
        formData.append(key, statusDetailsData[key]);
      });

      // Append the attachments with size and type
      if (attachmentFile && attachmentFile.length > 0) {
        attachmentFile.forEach(({ file, type }) => {
          formData.append("Attachment", file);
          formData.append("FileSize", file.size);
          formData.append("DocumentType", type);
        });
      }

      // Make the PUT request to update status details
      await axios.put(
        `${API_URL}/api/custody_log_status/${selectedData.id}`,
        formData,
        {
          headers: {
            Authorization: authKey,
            "Content-Type": "multipart/form-data", // Important for sending FormData
          },
        },
      );

      // Reset UI state after successful update
      setShowCasePropertyPopup(false);
      // fetchData();

      // Show success message in Snackbar
      setSnackbarMessage("Data updated successfully!");
      setOpenSnackbar(true);

      // Hide Snackbar after 1 second
      setTimeout(() => {
        setOpenSnackbar(false);
      }, 1000);
    } catch (error) {
      console.error("Error updating status details:", error);
    }
  };

  // const handleDateRangeChange = async (dates) => {
  //   const [start, end] = dates;
  //   setSelectedStartDate(start);
  //   setSelectedEndDate(end);

  //   // Only make API call if both dates are selected
  //   if (start && end) {
  //     try {
  //       const authKey = localStorage.getItem("authKey");
  //       const formattedStartDate = start.toISOString().split('T')[0];
  //       const formattedEndDate = end.toISOString().split('T')[0];

  //       const url = `${API_URL}/api/user/v1/data/filtered_crime_data?start_date=${formattedStartDate}&end_date=${formattedEndDate}`;

  //       const response = await axios.get(url, {
  //         headers: {
  //           Authorization: authKey,
  //         },
  //       });

  //       if (response.data.success) {
  //         setData(response.data.data);
  //         setFilteredData(response.data.data);
  //       } else {
  //         setSnackbarMessage(response.data.message || "No data found");
  //         setOpenSnackbar(true);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching filtered data:", error);
  //       setSnackbarMessage("Error fetching data");
  //       setOpenSnackbar(true);
  //     }
  //   }
  // };
  const handleDateRangeChange = (dates) => {
    const [start, end] = dates;
    setSelectedStartDate(start);
    setSelectedEndDate(end);
    setIsFormModified(true);
  };

  const resetForm = () => {
    setSelectedOption(DEFAULT_VIEW_DATE_FILTER_OPTION);
    setSelectedStartDate(null);
    setSelectedEndDate(null);
    setDateRangeVisible(false);
    setIsFormModified(false);
    localStorage.setItem(
      VIEW_DATE_FILTER_OPTION_STORAGE_KEY,
      DEFAULT_VIEW_DATE_FILTER_OPTION,
    );
  };

  useEffect(() => {
    if (selectedOption) {
      localStorage.setItem(VIEW_DATE_FILTER_OPTION_STORAGE_KEY, selectedOption);
    } else {
      localStorage.removeItem(VIEW_DATE_FILTER_OPTION_STORAGE_KEY);
    }
  }, [selectedOption]);

  useEffect(() => {
    setDateRangeVisible(selectedOption === "custom");
  }, [selectedOption]);

  useEffect(() => {
    if (
      selectedOption === "custom" &&
      (!selectedStartDate || !selectedEndDate)
    ) {
      return;
    }

    fetchData();
  }, [selectedEndDate, selectedOption, selectedStartDate]);

  const handleEditClick = async (row) => {
    try {
      const authKey = localStorage.getItem("authKey");
      const response = await axios.get(`${API_URL}/api/data/${row.id}`, {
        headers: {
          Authorization: authKey,
        },
      });
      const rowData = response.data;

      // Parse the section_of_law JSON string
      const sectionOfLawsData = JSON.parse(rowData.section_of_law);

      // Handle charge_sheet_date and next_court_date safely
      const chartSheetDate = rowData.chart_sheet_date
        ? new Date(rowData.chart_sheet_date)
        : null;
      const nextCourtDate = rowData.next_court_date
        ? new Date(rowData.next_court_date)
        : null;
      const normalizedUnit = matchOptionValue(
        masterUnitOptions,
        rowData.unit || row.unit || "",
      );
      const normalizedCasePropertyType = matchOptionValue(
        masterCasePropertyTypeOptions,
        rowData.muddamaal_type || row.muddamaal_type || "",
      );
      const normalizedVehicleReason = matchOptionValue(
        masterVehicleReasonOptions,
        rowData.vehicle_reason || row.vehicle_reason || "",
      );
      const normalizedStatus = matchOptionValue(
        masterStatusOptions,
        rowData.status_of_muddamaal || row.status_of_muddamaal || "",
      );

      setSelectedData(
        normalizeEntryTypeRecord(
          {
            ...row,
            act: rowData.act || "",
            section_of_law: rowData.section_of_law || "",
            specify_act: rowData.specify_act || "",
            chart_sheet_date: chartSheetDate,
            next_court_date: nextCourtDate,
            muddamaal_type:
              normalizedCasePropertyType ||
              rowData.muddamaal_type ||
              row.muddamaal_type ||
              "",
            vehicle_reason:
              normalizedVehicleReason ||
              rowData.vehicle_reason ||
              row.vehicle_reason ||
              "",
            unit: normalizedUnit || rowData.unit || row.unit || "",
            status_of_muddamaal:
              normalizedStatus ||
              rowData.status_of_muddamaal ||
              row.status_of_muddamaal ||
              "",
          },
          entryTypes,
        ),
      );

      // Set selected options for acts dropdown
      if (rowData.act && rowData.act.trim() !== "") {
        let selectedOptionsData = matchActOptionsByNames(
          rowData.act,
          masterActOptions,
        );

        if (rowData.specify_act?.trim()) {
          const otherMasterOption = masterActOptions.find((option) =>
            isOtherActOption(option),
          );
          const isStoredAsSpecifyActOnly =
            rowData.act.trim() === rowData.specify_act.trim();

          if (otherMasterOption && isStoredAsSpecifyActOnly) {
            selectedOptionsData = [otherMasterOption];
          }
        }
        setSelectedOptions(selectedOptionsData);
        const hasOtherActSelected = selectedOptionsData.some((option) =>
          isOtherActOption(option),
        );
        setShowSpecifyActInput(hasOtherActSelected);
        setShowSectionOfLawInput(!hasOtherActSelected);
        setSelectedAct(
          hasOtherActSelected
            ? rowData.specify_act || ""
            : selectedOptionsData.map((option) => option.name).join(", "),
        );
      } else {
        setSelectedOptions([]);
        setShowSpecifyActInput(false);
        setShowSectionOfLawInput(false);
        setSelectedAct("");
      }

      // Set specifyAct state
      setSpecifyAct(rowData.specify_act || "");
      setSelectedUnit(normalizedUnit || rowData.unit || row.unit || "");

      // Set sectionOfLaws state
      setSectionOfLaws(sectionOfLawsData);
      setEditValidationErrors({});

      // Hide popup and show edit form
      setShowPopup(false);
      setShowEditForm(true);
    } catch (error) {
      console.error(error);
    }
  };

  // console.log(translations[selectedLanguage]?.guna_number,"vussssal");

  useEffect(() => {
    if (!showEditForm && !showExportPopup) {
      return undefined;
    }

    let isMounted = true;

    const loadMasterOptions = async () => {
      try {
        const [
          casePropertyTypeResponse,
          unitResponse,
          actResponse,
          casePropertyStatusResponse,
          vehicleReasonResponse,
        ] = await Promise.all([
          getMasterDomainItems("case_property_type", {
            lang: selectedLanguage,
            state: userState,
          }),
          getMasterDomainItems("unit", {
            lang: selectedLanguage,
            state: userState,
          }),
          getMasterDomainItems("act", {
            lang: selectedLanguage,
            state: userState,
          }),
          getMasterDomainItems("case_property_status", {
            lang: selectedLanguage,
            state: userState,
          }),
          getMasterDomainItems("vehicle_reason", {
            lang: selectedLanguage,
            state: userState,
          }),
        ]);

        if (!isMounted) {
          return;
        }

        setMasterCasePropertyTypeOptions(
          buildCasePropertyTypeOptions(casePropertyTypeResponse.items),
        );
        setMasterUnitOptions(buildUnitOptions(unitResponse.items));
        setMasterActOptions(buildActOptions(actResponse.items));
        setMasterStatusOptions(
          buildStatusOptions(casePropertyStatusResponse.items),
        );
        setMasterVehicleReasonOptions(
          buildVehicleReasonOptions(vehicleReasonResponse.items),
        );
      } catch (error) {
        if (isMounted) {
          console.error(
            "Error fetching next court date master options:",
            error,
          );
        }
      }
    };

    loadMasterOptions();

    return () => {
      isMounted = false;
    };
  }, [selectedLanguage, showEditForm, showExportPopup, userState]);

  useEffect(() => {
    if (!showEditForm || !selectedData || typeof selectedData !== "object") {
      return;
    }

    if (masterCasePropertyTypeOptions.length > 0) {
      const matchedCasePropertyType = matchOptionValue(
        masterCasePropertyTypeOptions,
        selectedData.muddamaal_type,
      );
      const nextCasePropertyType =
        matchedCasePropertyType ||
        selectedData.muddamaal_type ||
        masterCasePropertyTypeOptions[0]?.value ||
        "";

      if (nextCasePropertyType !== selectedData.muddamaal_type) {
        setSelectedData((prevData) =>
          prevData && typeof prevData === "object"
            ? {
                ...prevData,
                muddamaal_type: nextCasePropertyType,
              }
            : prevData,
        );
      }

      const isVehicleType = isVehicleCasePropertyType(
        nextCasePropertyType,
        masterCasePropertyTypeOptions,
      );
      const matchedVehicleReason = matchOptionValue(
        masterVehicleReasonOptions,
        selectedData.vehicle_reason,
      );
      const nextVehicleReason = isVehicleType
        ? matchedVehicleReason ||
          selectedData.vehicle_reason ||
          masterVehicleReasonOptions[0]?.value ||
          ""
        : "";

      if (nextVehicleReason !== (selectedData.vehicle_reason || "")) {
        setSelectedData((prevData) =>
          prevData && typeof prevData === "object"
            ? {
                ...prevData,
                vehicle_reason: nextVehicleReason,
              }
            : prevData,
        );
      }
    }

    if (masterUnitOptions.length > 0) {
      const matchedUnit = matchOptionValue(
        masterUnitOptions,
        selectedData.unit || selectedUnit,
      );

      if (matchedUnit && matchedUnit !== selectedUnit) {
        setSelectedUnit(matchedUnit);
      }

      if (matchedUnit && matchedUnit !== selectedData.unit) {
        setSelectedData((prevData) =>
          prevData && typeof prevData === "object"
            ? {
                ...prevData,
                unit: matchedUnit,
              }
            : prevData,
        );
      }
    }

    if (masterStatusOptions.length > 0) {
      const matchedStatus = matchOptionValue(
        masterStatusOptions,
        selectedData.status_of_muddamaal,
      );

      if (matchedStatus && matchedStatus !== selectedData.status_of_muddamaal) {
        setSelectedData((prevData) =>
          prevData && typeof prevData === "object"
            ? {
                ...prevData,
                status_of_muddamaal: matchedStatus,
              }
            : prevData,
        );
      }
    }

    if (masterActOptions.length > 0 && selectedData.act) {
      let matchedOptions = matchActOptionsByNames(
        selectedData.act,
        masterActOptions,
      );

      if (selectedData.specify_act?.trim()) {
        const otherMasterOption = masterActOptions.find((option) =>
          isOtherActOption(option),
        );
        const isStoredAsSpecifyActOnly =
          selectedData.act.trim() === selectedData.specify_act.trim();

        if (otherMasterOption && isStoredAsSpecifyActOnly) {
          matchedOptions = [otherMasterOption];
        }
      }

      const hasOtherActSelected = matchedOptions.some((option) =>
        isOtherActOption(option),
      );

      setSelectedOptions(matchedOptions);
      setShowSpecifyActInput(hasOtherActSelected);
      setShowSectionOfLawInput(!hasOtherActSelected);
      setSelectedAct(
        hasOtherActSelected
          ? selectedData.specify_act || ""
          : matchedOptions.map((option) => option.name).join(", "),
      );
    }
  }, [
    masterActOptions,
    masterCasePropertyTypeOptions,
    masterStatusOptions,
    masterUnitOptions,
    masterVehicleReasonOptions,
    selectedData,
    selectedUnit,
    showEditForm,
  ]);

  useEffect(() => {
    let isMounted = true;

    const fetchEntryTypes = async () => {
      const authKey = localStorage.getItem("authKey");

      if (!authKey) {
        return;
      }

      try {
        const response = await axios.get(`${API_URL}/api/entry_types`, {
          headers: {
            Authorization: authKey,
          },
        });

        if (!isMounted) {
          return;
        }

        setEntryTypes(normalizeEntryTypeOptions(response.data));
      } catch (error) {
        console.error("Error fetching entry types:", error);
      }
    };

    fetchEntryTypes();

    return () => {
      isMounted = false;
    };
  }, []);

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };
  const showSnackbarMessage = (message, severity = "success") => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setOpenSnackbar(true);
  };

  const handleButtonClick = (id) => {
    // Navigate to a new screen or page with the specific id
    navigate(`/new-screen/${id}`);
  };

  const insertRef = useRef(null);
  const handleInsertPopupClose = () => {
    setShowInsertDataPopup(!showInsertDataPopup);
  };

  const handleRemarkChange = (event, id) => {
    setRemark({
      ...remark,
      [id]: event.target.value,
    });
  };

  const handleRemarkSet = async (id) => {
    const authKey = localStorage.getItem("authKey");
    const remarkText = remark[id] || "";

    try {
      const config = {
        headers: {
          Authorization: authKey,
          "Content-Type": "application/json",
        },
      };

      // Encode the payload
      const payload = { pendency_reason: remarkText };

      let response;
      if (isRemarkSet[id]) {
        // Update the existing remark
        response = await axios.put(
          `${API_URL}/api/update_pendency_reason/${id}`,
          payload,
          config,
        );
        setSnackbarMessage("Remark updated successfully");
        setOpenSnackbar(true);
      } else {
        // Add a new remark
        response = await axios.post(
          `${API_URL}/api/add_pendency_reason/${id}`,
          payload,
          config,
        );
        setSnackbarMessage("Remark added successfully");
        setOpenSnackbar(true);
      }

      // Save the remark to local storage
      const updatedRemarks = { ...remark, [id]: remarkText };
      localStorage.setItem("remarks", JSON.stringify(updatedRemarks));

      // Update state
      setEditingId(null); // Close the input after saving
      setIsRemarkSet((prevState) => ({
        ...prevState,
        [id]: true, // Set the remark as saved
      }));

      // Hide success message after 3 seconds
      setTimeout(() => {
        setIsRemarkSet((prevState) => ({
          ...prevState,
          [id]: false, // Reset the saved status after 3 seconds
        }));
      }, 1000);

      setTimeout(() => {
        setOpenSnackbar(false);
      }, 1000);
    } catch (error) {
      console.error(
        "Error setting remark:",
        error.response ? error.response.data : error.message,
      );
      setSnackbarMessage("Error setting remark");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (insertRef.current && !insertRef.current.contains(event.target)) {
        setShowInsertDataPopup(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  const handleSrNoFilterChange = (e) => {
    setSrNoFilter(e.target.value);
  };

  const handleGunaNoFilterChange = (e) => {
    setGunaNoFilter(e.target.value);
  };

  const handleFilterCancel = (column) => {
    if (column === "srNo") {
      setSrNoFilterPopupOpen(false);
      setSrNoSortOption("");
      setSrNoFilterApplied(false);
    } else if (column === "gunaNo") {
      setGunaNoFilterPopupOpen(false);
      setGunaNoSortOption("");
      setGunaNoFilterApplied(false);
    }

    // Add similar logic for other columns
  };
  const handleAttachmentIconClick = (id) => {
    navigate(`/attachment/${id}`, {
      state: {
        from: {
          pathname: `${location.pathname}${location.search}`,
          state: location.state ?? null,
        },
      },
    });
  };

  const handleFilterApply = (column) => {
    // Apply the selected filter options to your data here
    if (column === "srNo") {
      // Apply srNoFilter and srNoSortOption to your data
      setSrNoFilterApplied(true);
      setSrNoFilterPopupOpen(false);
    } else if (column === "gunaNo") {
      setGunaNoFilterApplied(true);
      setGunaNoFilterPopupOpen(false);
    }
  };

  const onPaginationChange = (start, end) => {
    if (pagination.start !== start || pagination.end !== end) {
      setPagination({ start: start, end: end });
    }
  };

  const handleShowPerPageChange = (e) => {
    const selectedShowPerPage = parseInt(e.target.value, 10);
    setShowPerPage(selectedShowPerPage);
    setPagination({ start: 0, end: selectedShowPerPage });
  };

  const debouncedFilterAndSortData = _debounce(() => {
    filterAndSortData();
  });

  useEffect(() => {
    debouncedFilterAndSortData();
  }, [searchText, sortOrder, debouncedFilterAndSortData]);

  const handleSortOrderChange = (event) => {
    const newSortOrder = event.target.value;
    setSortOrder(newSortOrder);
    filterAndSortData();
  };
  const handleFilterIconClick = (column) => {
    // Toggle the state of the filter popup for the clicked column
    if (column === "srNo") {
      setSrNoFilterPopupOpen(!srNoFilterPopupOpen);
    } else if (column === "gunaNo") {
      setGunaNoFilterPopupOpen(!gunaNoFilterPopupOpen);
    }
    // Add similar logic for other columns
  };

  const sortData = (dataToSort) => {
    return dataToSort.sort((a, b) => {
      switch (sortOrder) {
        case "નવીનતમ":
          return new Date(b.date_of_seizure) - new Date(a.date_of_seizure);
        case "જૂના":
          return new Date(a.date_of_seizure) - new Date(b.date_of_seizure);
        case "AtoZ":
          return a.description.localeCompare(b.description);
        case "ZtoA":
          return b.description.localeCompare(a.description);
        case "તારીખ":
          return new Date(b.date_of_seizure) - new Date(a.date_of_seizure);
        case "સરનો":
          return parseInt(a.serial_number) - parseInt(b.serial_number);
        case "ગુના_નો":
          return parseInt(a.guna_number) - parseInt(b.guna_number);
        case "તારીખ_જપ્ત_કર્યા_ની":
          return new Date(a.date_of_seizure) - new Date(b.date_of_seizure);
        case "મુદ્દામાલ_પાવતી_નો":
          return parseInt(a.exhibit_number) - parseInt(b.exhibit_number);
        case "જથ્થો":
          return parseInt(a.quantity) - parseInt(b.quantity);
        case "કિંમત":
          return parseInt(a.price) - parseInt(b.price);
        default:
          return 0;
      }
    });
  };

  const filterAndSortData = () => {
    const searchTextLowerCase = searchText.toLowerCase();
    const filteredAndSortedData = data.filter((row) => {
      return Object.values(row).some(
        (value) =>
          value && value.toString().toLowerCase().includes(searchTextLowerCase),
      );
    });

    const sortedData = sortData(filteredAndSortedData);
    setFilteredData(sortedData);
  };

  const openExportPopup = () => {
    setExportOptions({
      ...INITIAL_EXPORT_OPTIONS,
      lang: selectedLanguage,
    });
    setShowExportPopup(true);
  };

  const closeExportPopup = () => {
    if (isExporting) {
      return;
    }

    setShowExportPopup(false);
  };

  const handleExportOptionChange = (fieldName) => (event) => {
    const nextValue = event?.target?.value ?? "";

    setExportOptions((prevOptions) => ({
      ...prevOptions,
      [fieldName]: nextValue,
    }));
  };

  const exportCasePropertyData = async () => {
    if (isExporting) {
      return;
    }

    if (
      (exportOptions.startDate && !exportOptions.endDate) ||
      (!exportOptions.startDate && exportOptions.endDate)
    ) {
      showSnackbarMessage(
        "Please select both start date and end date.",
        "error",
      );
      return;
    }

    if (
      exportOptions.startDate &&
      exportOptions.endDate &&
      new Date(exportOptions.startDate) > new Date(exportOptions.endDate)
    ) {
      showSnackbarMessage("Start date cannot be after end date.", "error");
      return;
    }

    setIsExporting(true);

    try {
      const response = await exportCrimeData({
        entryType: exportOptions.entryType,
        filters:
          exportOptions.startDate && exportOptions.endDate
            ? {
                startDate: exportOptions.startDate,
                endDate: exportOptions.endDate,
              }
            : {},
        format: exportOptions.format,
        lang: exportOptions.lang,
        status: exportOptions.status,
      });
      const blob =
        response?.data instanceof Blob
          ? response.data
          : new Blob([response?.data]);
      const downloadUrl = window.URL.createObjectURL(blob);
      const downloadLink = document.createElement("a");

      downloadLink.href = downloadUrl;
      downloadLink.download = extractFilenameFromHeaders(response?.headers);
      document.body.appendChild(downloadLink);
      downloadLink.click();
      downloadLink.remove();
      window.URL.revokeObjectURL(downloadUrl);
      setShowExportPopup(false);
      showSnackbarMessage("Records exported successfully.", "success");
    } catch (error) {
      console.error("Error exporting case property records:", error);
      const errorMessage =
        error?.response?.status === 404
          ? "No records found for the selected export filters."
          : "Unable to export records with the selected filters.";
      showSnackbarMessage(errorMessage, "error");
    } finally {
      setIsExporting(false);
    }
  };

  const handleView = (id) => {
    const selectedDataRow = filteredData.find((row) => row.id === id);
    setFilteredData(selectedDataRow);
    setShowPopup(true);
    setShowEditForm(false);
  };

  const handleFilterChange = (event) => {
    setSearchText(event.target.value);
    debouncedFilterAndSortData();
  };

  const generateHighlightedText = (text, searchText) => {
    if (!searchText || searchText === "" || typeof text !== "string") {
      return text;
    }
    const regex = new RegExp(searchText, "gi");
    return text.replace(regex, (match) => `<mark>${match}</mark>`);
  };

  const optionss = [
    { value: "today", label: "Today" },
    { value: "this_month", label: "This Month" },
    { value: "next_month", label: "Next Month" },
    { value: "last_week", label: "Last Week" },
    { value: "last_month", label: "Last Month" },
    { value: "last_three_months", label: "Last 3 Months" },
    { value: "last_six_months", label: "Last 6 Months" },
    { value: "custom", label: "Custom Date" },
  ];

  function formatDate(inputDate) {
    const options = {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    };

    const date = new Date(inputDate);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = date.getFullYear();

    const formattedDate = `${day}/${month}/${year}`;
    return formattedDate;
  }

  function formatDates(inputDate) {
    const options = {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
      timeZone: "UTC",
    };

    const date = new Date(inputDate);

    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const year = date.getUTCFullYear();

    const hours = String(date.getUTCHours()).padStart(2, "0");
    const minutes = String(date.getUTCMinutes()).padStart(2, "0");

    const formattedDate = `${day}/${month}/${year} ${hours}:${minutes}`;
    return formattedDate;
  }

  const truncateTextByWordLimit = (text, wordLimit = 5) => {
    const safeText = normalizeTextValue(text);
    const words = safeText.split(" ");
    return words.length > wordLimit
      ? words.slice(0, wordLimit).join(" ") + "..."
      : safeText;
  };

  function truncateText(text) {
    const safeText = normalizeTextValue(text);
    const words = safeText.split(" ");
    if (words.length === 1) {
      return safeText; // Return the full word if it's a single word
    }

    return words[0]; // Return the first word
  }

  return (
    <>
      <Navbar />
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          severity={snackbarSeverity}
          onClose={handleSnackbarClose}
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>

      <div className="datalist-main-container next-court-date-page datalist-fit-layout new_datalist-layout">
        <div className="datalist-main-container-header new_datalist-header">
          <div className="datalist-left-side-header new_datalist-header-group new_datalist-header-group--left">
            <div className="search-bar new_datalist-search">
              <div className="input-container">
                <input
                  type="text"
                  id="filterInput"
                  value={searchText}
                  onChange={handleFilterChange}
                  placeholder="Search"
                />
                <img src="/Vector.png" alt="Logo" className="icon-search" />
              </div>
            </div>
            <div className="sort-bar new_datalist-sort">
              <SearchableSelect
                value={sortOrder}
                onChange={handleSortOrderChange}
                searchPlaceholder="Search sort options"
              >
                <option value="નવીનતમ">Sort by latest</option>
                <option value="જૂના">Sort by oldest</option>
                <option value="AtoZ">Sort by A to Z</option>
                <option value="ZtoA">Sort by Z to A</option>
                <option value="તારીખ">Sort by Date</option>
                <option value="સરનો">Sort by Sr.No.</option>
                <option value="ગુના_નો">
                  Sort by {translatedText("guna_number")}
                </option>
                <option value="તારીખ_જપ્ત_કર્યા_ની">
                  Sort by {translatedText("date_of_seizure")}
                </option>
                <option value="મુદ્દામાલ_પાવતી_નો">
                  Sort by {translatedText("exhibit_number")}
                </option>
                <option value="જથ્થો">
                  Sort by {translatedText("quantity")}
                </option>
                <option value="કિંમત">Sort by {translatedText("price")}</option>
              </SearchableSelect>
            </div>
          </div>
          <div className="datalist-center-side-header new_datalist-filter-region">
            <div className="police-dropdown-list new_datalist-filter-shell">
              <div className="police-dropdowns-list new_datalist-filter-inner">
                <HierarchyFilterBar
                  allDatesOptionValue={ALL_DATES_FILTER_OPTION}
                  className="new_report-filter-bar new_report-filter-bar--next-court"
                  compact
                  hideDateFilterLabel
                  showDistrictFilter={false}
                  showSubDivisionFilter={false}
                  showStationFilter={false}
                  selectedFilterOption={selectedOption}
                  selectedStartDate={selectedStartDate}
                  selectedEndDate={selectedEndDate}
                  onFilterOptionChange={handleChange}
                  onDateRangeChange={handleDateRangeChange}
                  onReset={resetForm}
                  quickFilterOptions={optionss}
                  showDateFilters
                  showReset={isFormModified}
                />
              </div>
            </div>
          </div>

          <div className="datalist-right-side-header new_datalist-header-group new_datalist-header-group--right">
            <div className="export-btn new_datalist-secondary-action">
              <button
                className=""
                onClick={openExportPopup}
                disabled={isExporting}
                type="button"
              >
                Export
                {/* <BiExport className="icons-export" /> */}
                <img src="/Vector-.png" alt="Logo" className="icons-export" />
              </button>
            </div>
          </div>
        </div>
        <style>{keyframesStyle}</style>
        {loading ? (
          <div style={containerStyle}>
            <div style={loaderStyle}></div>
          </div>
        ) : (
          <>
            {filteredData && filteredData.length > 0 ? (
              <div className="datalist-main-container-body new_datalist-body">
                <div className="datalist-scroll-body new_datalist-scroll-body">
                  <div className="data-list-table container50 new_datalist-table-shell">
                    <table className="tables new_datalist-table">
                      <thead className="data-list-table-header new_datalist-table-head">
                        <tr>
                          {/* <th className="page-sticky-col page-sticky-col--start"> */}
                          <th>
                            {translatedText("sr_no")}
                            <span
                              className="filter-icon"
                              onClick={() => handleFilterIconClick("srNo")}
                            >
                              <CgArrowsScrollV className="icon-filter" />
                            </span>
                            {srNoFilterPopupOpen && (
                              <div className="filter-popup">
                                <input
                                  type="text"
                                  className="search-text"
                                  value={srNoFilter}
                                  onChange={handleSrNoFilterChange}
                                  placeholder="Filter Sr. No"
                                />
                                <div className="filter-options">
                                  <label>
                                    <input
                                      type="radio"
                                      name="sortOption"
                                      value="az"
                                      checked={srNoSortOption === "az"}
                                      onChange={() => setSrNoSortOption("az")}
                                    />
                                    Sort by A to Z
                                  </label>
                                  <label>
                                    <input
                                      type="radio"
                                      name="sortOption"
                                      value="za"
                                      checked={srNoSortOption === "za"}
                                      onChange={() => setSrNoSortOption("za")}
                                    />
                                    Sort by Z to A
                                  </label>
                                  <label>
                                    <input
                                      type="radio"
                                      name="sortOption"
                                      value="values"
                                      checked={srNoSortOption === "values"}
                                      onChange={() =>
                                        setSrNoSortOption("values")
                                      }
                                    />
                                    Sort by Values
                                  </label>
                                </div>
                                <div className="filter-buttons">
                                  <button
                                    onClick={() => handleFilterCancel("srNo")}
                                  >
                                    Cancel
                                  </button>
                                  <button
                                    onClick={() => handleFilterApply("srNo")}
                                  >
                                    OK
                                  </button>
                                </div>
                              </div>
                            )}
                          </th>

                          {(userState === "Andaman and Nicobar" ||
                            userState === "Maharashtra" ||
                            userState === "Goa") && (
                            <th>{translatedText("exhibit_number")}</th>
                          )}

                          <th>
                            {translatedText("guna_number")}
                            <span
                              className="filter-icon"
                              onClick={() => handleFilterIconClick("gunaNo")}
                            >
                              <CgArrowsScrollV className="icon-filter" />
                            </span>
                            {gunaNoFilterPopupOpen && (
                              <div className="filter-popup">
                                <input
                                  type="text"
                                  className="search-text"
                                  value={gunaNoFilter}
                                  onChange={handleGunaNoFilterChange}
                                  placeholder="Filter Sr. No"
                                />
                                <div className="filter-options">
                                  <label>
                                    <input
                                      type="radio"
                                      name="sortOption"
                                      value="az"
                                      checked={gunaNoSortOption === "az"}
                                      onChange={() => setGunaNoSortOption("az")}
                                    />
                                    Sort by A to Z
                                  </label>
                                  <label>
                                    <input
                                      type="radio"
                                      name="sortOption"
                                      value="za"
                                      checked={gunaNoSortOption === "za"}
                                      onChange={() => setGunaNoSortOption("za")}
                                    />
                                    Sort by Z to A
                                  </label>
                                  <label>
                                    <input
                                      type="radio"
                                      name="sortOption"
                                      value="values"
                                      checked={gunaNoSortOption === "values"}
                                      onChange={() =>
                                        setGunaNoSortOption("values")
                                      }
                                    />
                                    Sort by Values
                                  </label>
                                </div>
                                <div className="filter-buttons">
                                  <button
                                    onClick={() => handleFilterCancel("gunaNo")}
                                  >
                                    Cancel
                                  </button>
                                  <button
                                    onClick={() => handleFilterApply("gunaNo")}
                                  >
                                    OK
                                  </button>
                                </div>
                              </div>
                            )}
                          </th>
                          {localStorage.getItem("admin") === "1" && (
                            <th>{translatedText("police_station")}</th>
                          )}
                          <th>{translatedText("date_of_seizure")}</th>
                          {userState === "Gujarat" && (
                            <th>{translatedText("exhibit_number")}</th>
                          )}
                          <th>{translatedText("muddamaal_type")}</th>
                          <th>{translatedText("unit")}</th>
                          <th>{translatedText("quantity")}</th>
                          {userState === "Gujarat" && (
                            <th>{translatedText("price")}</th>
                          )}
                          <th>{translatedText("status_of_muddamaal")}</th>
                          <th>{translatedText("updated_on")}</th>
                          <th>{translatedText("act_section_of_low")}</th>
                          <th>{translatedText("description")}</th>
                          <th>{translatedText("chart_sheet_date")}</th>
                          <th>{translatedText("next_court_date")}</th>
                          <th className="clms1">
                            {translatedText("reason_for_pendency")}
                          </th>
                          <th>{translatedText("attachment")}</th>
                          <th className="page-sticky-col page-sticky-col--end">
                            {translatedText("action")}
                          </th>
                        </tr>
                      </thead>
                      <tbody className="data-list-table-body new_datalist-table-body">
                        {filteredData
                          .filter(
                            (row) => row.serial_number.includes(srNoFilter),
                            // Add similar conditions for other filterable columns
                          )
                          .sort((a, b) => {
                            if (srNoSortOption === "az") {
                              return a.serial_number.localeCompare(
                                b.serial_number,
                              );
                            } else if (srNoSortOption === "za") {
                              return b.serial_number.localeCompare(
                                a.serial_number,
                              );
                            } else {
                              // Handle sorting by values (you may need to modify this logic)
                              return 0;
                            }
                          })
                          .slice(pagination.start, pagination.end)
                          .map((row) => (
                            <tr key={row.id}>
                              <td
                                className="clm1 page-sticky-cell page-sticky-cell--start"
                                dangerouslySetInnerHTML={{
                                  __html: generateHighlightedText(
                                    row.serial_number,
                                    searchText,
                                  ),
                                }}
                              />
                              {(userState === "Andaman and Nicobar" ||
                                userState === "Maharashtra" ||
                                userState === "Goa") && (
                                <td
                                  className="clm4"
                                  dangerouslySetInnerHTML={{
                                    __html: generateHighlightedText(
                                      row.exhibit_number || "NA",
                                      searchText,
                                    ),
                                  }}
                                />
                              )}

                              <td
                                className="clm2"
                                dangerouslySetInnerHTML={{
                                  __html: generateHighlightedText(
                                    row.guna_number || "NA",
                                    searchText,
                                  ),
                                }}
                              />
                              {localStorage.getItem("admin") === "1" && (
                                <td
                                  className="clm2"
                                  dangerouslySetInnerHTML={{
                                    __html: generateHighlightedText(
                                      row.police_station || "NA",
                                      searchText,
                                    ),
                                  }}
                                />
                              )}
                              <td
                                className="clm3"
                                dangerouslySetInnerHTML={{
                                  __html: generateHighlightedText(
                                    formatDate(row.date_of_seizure || "NA"),
                                    searchText,
                                  ),
                                }}
                              />
                              {userState === "Gujarat" && (
                                <td
                                  className="clm4"
                                  dangerouslySetInnerHTML={{
                                    __html: generateHighlightedText(
                                      row.exhibit_number || "NA",
                                      searchText,
                                    ),
                                  }}
                                />
                              )}
                              <td
                                className={`clm5 ${
                                  row.muddamaal_type === "અન્ય" ||
                                  row.muddamaal_type === "Others" ||
                                  row.muddamaal_type === "इतर" ||
                                  row.muddamaal_type === "भाग-5" ||
                                  row.muddamaal_type === "अन्य"
                                    ? "custom-bg-color-1"
                                    : row.muddamaal_type ===
                                          "ડ્રગ્સ & નાર્કોટિક્સ" ||
                                        row.muddamaal_type ===
                                          "Drugs & Narcotics" ||
                                        row.muddamaal_type ===
                                          "औषधे आणि अंमली पदार्थ" ||
                                        row.muddamaal_type === "भाग-6" ||
                                        row.muddamaal_type ===
                                          "ड्रग्स और नारकोटिक्स"
                                      ? "custom-bg-color-2"
                                      : row.muddamaal_type ===
                                            "સાંસ્કૃતિક મિલકત" ||
                                          row.muddamaal_type ===
                                            "Cultural Heritage" ||
                                          row.muddamaal_type ===
                                            "सांस्कृतिक वारसा" ||
                                          row.muddamaal_type ===
                                            "प्रोहिबिशन (दारूबंदी)" ||
                                          row.muddamaal_type ===
                                            "सांस्कृतिक विरासत"
                                        ? "custom-bg-color-3"
                                        : row.muddamaal_type === "ચલણી નાણું" ||
                                            row.muddamaal_type ===
                                              "Counterfeit Currency" ||
                                            row.muddamaal_type ===
                                              "बनावट चलन" ||
                                            row.muddamaal_type === "नकली मुद्रा"
                                          ? "custom-bg-color-4"
                                          : row.muddamaal_type ===
                                                "અગ્નિ હથિયાર" ||
                                              row.muddamaal_type ===
                                                "Firearms" ||
                                              row.muddamaal_type ===
                                                "आकस्मिक मृत्यू (अ.मु.)" ||
                                              row.muddamaal_type === "बंदुक" ||
                                              row.muddamaal_type ===
                                                "आग्नेयास्त्रों"
                                            ? "custom-bg-color-5"
                                            : row.muddamaal_type ===
                                                  "અન્ય હથિયાર" ||
                                                row.muddamaal_type ===
                                                  "Other Weapons" ||
                                                row.muddamaal_type ===
                                                  "इतर शस्त्रे" ||
                                                row.muddamaal_type ===
                                                  "इतर शस्त्रे" ||
                                                row.muddamaal_type === "बेवारस"
                                              ? "custom-bg-color-6"
                                              : row.muddamaal_type?.trim() ===
                                                    "મોબાઈલ અને ઇલેક્ટ્રોનિક ઇકવિપમેનટ" ||
                                                  row.muddamaal_type?.trim() ===
                                                    "Mobile and Electronic Equipments" ||
                                                  row.muddamaal_type?.trim() ===
                                                    "Mobile and Electronic Equipments" ||
                                                  row.muddamaal_type?.trim() ===
                                                    "मोबाइल आणि इलेक्ट्रॉनिक उपकरणे"
                                                ? "custom-bg-color-12"
                                                : row.muddamaal_type ===
                                                      "IMFL" ||
                                                    row.muddamaal_type ===
                                                      "आय एम एफ एल" ||
                                                    row.muddamaal_type ===
                                                      "आईएमएफएल"
                                                  ? "custom-bg-color-6"
                                                  : row.muddamaal_type ===
                                                        "Gold and Jewellery" ||
                                                      row.muddamaal_type ===
                                                        "Gold and Jewellery" ||
                                                      row.muddamaal_type ===
                                                        "सोने आणि दागिने"
                                                    ? "custom-bg-color-3"
                                                    : row.muddamaal_type ===
                                                          "Illicit liquor" ||
                                                        row.muddamaal_type ===
                                                          "Illicit liquor" ||
                                                        row.muddamaal_type ===
                                                          "अवैध दारू"
                                                      ? "custom-bg-color-4"
                                                      : row.muddamaal_type ===
                                                            "Handia" ||
                                                          row.muddamaal_type ===
                                                            "हंडिया" ||
                                                          row.muddamaal_type ===
                                                            "हंडिया"
                                                        ? "custom-bg-color-5"
                                                        : row.muddamaal_type ===
                                                              "Counterfeit Goods" ||
                                                            row.muddamaal_type ===
                                                              "बनावट वस्तू" ||
                                                            row.muddamaal_type ===
                                                              "नकली माल"
                                                          ? "custom-bg-color-10"
                                                          : row.muddamaal_type ===
                                                                "વાહન" ||
                                                              row.muddamaal_type ===
                                                                "Vehicle" ||
                                                              row.muddamaal_type ===
                                                                "Vehicle" ||
                                                              row.muddamaal_type ===
                                                                "वाहन"
                                                            ? "custom-bg-color-13"
                                                            : ""
                                }`}
                              >
                                {row.muddamaal_type === "વાહન" ||
                                row.muddamaal_type === "Vehicle" ? (
                                  <div className="custom-tooltip-container">
                                    <span
                                      className="custom-truncated"
                                      style={{
                                        color: "#003005",
                                        fontSize: "12px",
                                        fontWeight: "500",
                                      }}
                                      dangerouslySetInnerHTML={{
                                        __html: generateHighlightedText(
                                          truncateText(row.muddamaal_type, 2),
                                          searchText,
                                        ),
                                      }}
                                    />
                                    <span
                                      className="custom-truncated"
                                      style={{
                                        fontSize: "12px",
                                        fontWeight: "500",
                                      }}
                                      dangerouslySetInnerHTML={{
                                        __html: `(${generateHighlightedText(
                                          truncateText(row.vehicle_reason, 2),
                                          searchText,
                                        )})`,
                                      }}
                                    />
                                    <span className="custom-tooltiptext">
                                      {row.vehicle_reason}
                                    </span>
                                  </div>
                                ) : (
                                  <div className="custom-tooltip-container">
                                    <span
                                      className="custom-truncated"
                                      style={{
                                        color: "#003005",
                                        fontSize: "12px",
                                        fontWeight: "500",
                                      }}
                                      dangerouslySetInnerHTML={{
                                        __html: generateHighlightedText(
                                          truncateText(
                                            row.muddamaal_type || "NA",
                                            2,
                                          ),
                                          searchText,
                                        ),
                                      }}
                                    />
                                    <span className="custom-tooltiptext">
                                      {row.muddamaal_type || "NA"}
                                    </span>
                                  </div>
                                )}
                              </td>

                              <td className="clm6">{row.unit || "NA"}</td>
                              <td
                                className="clm6"
                                dangerouslySetInnerHTML={{
                                  __html: generateHighlightedText(
                                    row.quantity !== null &&
                                      row.quantity !== undefined
                                      ? row.quantity.toString()
                                      : "NA",
                                    searchText,
                                  ),
                                }}
                              />

                              {userState === "Gujarat" && (
                                <td
                                  className="clm7"
                                  dangerouslySetInnerHTML={{
                                    __html: `₹ ${generateHighlightedText(
                                      row.price || "NA",
                                      searchText,
                                    )}`,
                                  }}
                                ></td>
                              )}

                              <td className="clm8">
                                <span
                                  className="status-text"
                                  dangerouslySetInnerHTML={{
                                    __html: generateHighlightedText(
                                      row.status_of_muddamaal || "NA",
                                      searchText,
                                    ),
                                  }}
                                />
                                <div className="custody-bottom">
                                  <button
                                    className="custody-logs"
                                    onClick={() => handleButtonClick(row.id)}
                                  >
                                    Custody Log
                                  </button>
                                </div>
                                {isPopupOpen && <CustodyLog />}
                              </td>

                              <td
                                className="clm9"
                                dangerouslySetInnerHTML={{
                                  __html: generateHighlightedText(
                                    formatDates(row.created_at || "NA"),
                                    searchText,
                                  ),
                                }}
                              />

                              <td
                                className="clm0"
                                style={{
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {row.section_of_law ? (
                                  <Tooltip
                                    title={(() => {
                                      try {
                                        const parsedLaw = JSON.parse(
                                          row.section_of_law,
                                        );
                                        const lawEntries =
                                          Object.entries(parsedLaw);

                                        return (
                                          <table className="tooltip-table">
                                            <thead>
                                              <tr>
                                                <th className="acts-data">
                                                  Acts
                                                </th>
                                                <th className="laws-data">
                                                  Section of Laws
                                                </th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {lawEntries.map(
                                                ([lawKey, lawValue], index) => (
                                                  <tr key={index}>
                                                    <td>
                                                      {lawKey === "Others Acts"
                                                        ? `Others Acts (${row.specify_act})`
                                                        : lawKey || "NA"}
                                                    </td>
                                                    <td>{lawValue || "NA"}</td>
                                                  </tr>
                                                ),
                                              )}
                                            </tbody>
                                          </table>
                                        );
                                      } catch (error) {
                                        console.error(
                                          "Error parsing section_of_law:",
                                          error,
                                        );
                                        return "NA";
                                      }
                                    })()}
                                    arrow
                                    //
                                    PopperProps={{
                                      sx: {
                                        "& .MuiTooltip-tooltip": {
                                          backgroundColor: "transparent", // Your custom background
                                          color: "#000", // Text color
                                          border: "1px solid blue", // Border for the tooltip
                                          padding: "0px",
                                          marginLeft: "10px",
                                          marginTop: "-5px",
                                        },
                                        "& .MuiTooltip-arrow": {
                                          color: "#14195d",
                                          "&:before": {},
                                        },
                                      },
                                    }}
                                  >
                                    <span>
                                      view
                                      <BsInfoCircle className="person-icon" />
                                    </span>
                                  </Tooltip>
                                ) : (
                                  "NA"
                                )}
                              </td>

                              {/* <td className="clm10">
                                  <div className="tooltip-container">
                                    <span
                                      dangerouslySetInnerHTML={{
                                        __html: generateHighlightedText(
                                          truncateTextByCharLimit(
                                            row.description || "NA"
                                          ),
                                          searchText
                                        ),
                                      }}
                                    />
                                    <span className="tooltiptext">
                                      {row.description || "NA"}
                                    </span>
                                  </div>
                                </td> */}
                              <td className="clm10">
                                <div className="tooltip-container">
                                  <span
                                    dangerouslySetInnerHTML={{
                                      __html: generateHighlightedText(
                                        truncateTextByWordLimit(
                                          row.description || "NA",
                                        ), // Now truncating by words
                                        searchText,
                                      ),
                                    }}
                                  />
                                  <span className="tooltiptext">
                                    {row.description || "NA"}{" "}
                                    {/* Full description in the tooltip */}
                                  </span>
                                </div>
                              </td>

                              <td>
                                {formatDate(row.chart_sheet_date || "NA")}
                              </td>

                              <td>{formatDate(row.next_court_date || "NA")}</td>

                              <td className="clms1" style={{ padding: "8px" }}>
                                <div
                                  className="remarkbar1"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                  }}
                                >
                                  <Tooltip
                                    title={
                                      row.pendency_reason ||
                                      "No reason available"
                                    }
                                    arrow
                                  >
                                    <TextField
                                      variant="outlined"
                                      size="small"
                                      value={
                                        remark[row.id] ??
                                        row.pendency_reason ??
                                        ""
                                      }
                                      onChange={(e) =>
                                        handleRemarkChange(e, row.id)
                                      }
                                      InputProps={{
                                        readOnly: editingId !== row.id,
                                        style: {
                                          border:
                                            editingId === row.id
                                              ? "2px solid #4189db"
                                              : "1px solid #d3d3d3",
                                          transition: "border-color 0.3s ease",
                                        },
                                      }}
                                      fullWidth
                                    />
                                  </Tooltip>

                                  <div
                                    className="icon-set-remark"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    {editingId === row.id ? (
                                      <IconButton
                                        color="primary"
                                        onClick={() => {
                                          handleRemarkSet(row.id);
                                          setEditingId(null);
                                        }}
                                        size="small"
                                        aria-label="Save remark"
                                      >
                                        <CheckCircleIcon />
                                      </IconButton>
                                    ) : (
                                      <IconButton
                                        color="default"
                                        onClick={() => setEditingId(row.id)} // Enter editing mode
                                        size="small" // Matches input height better
                                        aria-label="Edit remark"
                                      >
                                        <EditIcon />
                                      </IconButton>
                                    )}
                                  </div>
                                </div>
                                <div className="remark-set-success"></div>
                              </td>
                              <td className="clm1">
                                <Tooltip title="Attachments" arrow>
                                  <span
                                    className="inquiry-file-btn"
                                    onClick={() =>
                                      handleAttachmentIconClick(row.id)
                                    }
                                  >
                                    <MdAttachFile className="inquiry-file-icon" />
                                  </span>
                                </Tooltip>
                              </td>
                              <td className="clm11 page-sticky-cell page-sticky-cell--end">
                                <div className="action-button">
                                  <div
                                    className="popup-button print-datalist"
                                    onClick={() => handleView(row.id)}
                                  >
                                    {/* <HiOutlinePrinter className="view-btn" /> */}
                                    <IoPrintOutline className="view-btn" />
                                    <div className="popup-index">Print</div>
                                  </div>
                                  {localStorage.getItem("admin") !== "1" && (
                                    <div
                                      className="popup-button edit-datalist"
                                      onClick={() => handleEditClick(row)}
                                    >
                                      {/* <BiEdit className="edit-btn" /> */}
                                      <FiEdit className="edit-btn" />
                                      <div className="popup-index">Edit</div>
                                    </div>
                                  )}
                                  {/* <div
                                      className="popup-button delete-datalist"
                                      onClick={() => handleDeleteClick(row.id)}
                                    >
                                     
                                      <MdDeleteOutline className="delete-btn" />
                                      <div className="popup-index">Delete</div>
                                    </div> */}
                                </div>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            ) : (
              <div className="no-data-message1">
                <p>No data available for the selected filter.</p>
              </div>
            )}
          </>
        )}
      </div>

      <Pagination
        className="pagination--compact new_datalist-pagination"
        showPerPage={showPerPage}
        total={data.length}
        onPaginationChange={onPaginationChange}
        handleShowPerPageChange={handleShowPerPageChange}
      />
      {showExportPopup && (
        <div
          className="export-popup-overlay"
          onClick={closeExportPopup}
          role="presentation"
        >
          <div
            className="export-popup"
            onClick={(event) => event.stopPropagation()}
            role="dialog"
            aria-modal="true"
            aria-labelledby="export-popup-title"
          >
            <div className="export-popup__header">
              <div>
                <h3 id="export-popup-title">Export Case Property</h3>
                <p>Choose format and export filters.</p>
              </div>
              <button
                type="button"
                className="export-popup__close"
                onClick={closeExportPopup}
                disabled={isExporting}
                aria-label="Close export popup"
              >
                <IoMdClose />
              </button>
            </div>

            <div className="export-popup__section">
              <label className="export-popup__label">Format</label>
              <div className="export-popup__radio-group">
                <label
                  className="export-popup__radio-option"
                  htmlFor="view-date-export-format-xlsx"
                >
                  <input
                    id="view-date-export-format-xlsx"
                    type="radio"
                    name="view-date-export-format"
                    value="xlsx"
                    checked={exportOptions.format === "xlsx"}
                    onChange={handleExportOptionChange("format")}
                    disabled={isExporting}
                  />
                  <span>Excel (.xlsx)</span>
                </label>
                <label
                  className="export-popup__radio-option"
                  htmlFor="view-date-export-format-csv"
                >
                  <input
                    id="view-date-export-format-csv"
                    type="radio"
                    name="view-date-export-format"
                    value="csv"
                    checked={exportOptions.format === "csv"}
                    onChange={handleExportOptionChange("format")}
                    disabled={isExporting}
                  />
                  <span>CSV (.csv)</span>
                </label>
              </div>
            </div>

            <div className="export-popup__grid">
              <div className="export-popup__field">
                <label
                  className="export-popup__label"
                  htmlFor="view-date-export-language"
                >
                  Language
                </label>
                <select
                  id="view-date-export-language"
                  className="export-popup__input"
                  value={exportOptions.lang}
                  onChange={handleExportOptionChange("lang")}
                  disabled={isExporting}
                >
                  <option value="en">English</option>
                  <option value="gu">Gujarati</option>
                  <option value="hi">Hindi</option>
                  <option value="mr">Marathi</option>
                </select>
              </div>

              <div className="export-popup__field">
                <label
                  className="export-popup__label"
                  htmlFor="view-date-export-status"
                >
                  Status
                </label>
                <SearchableSelect
                  id="view-date-export-status"
                  className="export-popup__select"
                  value={exportOptions.status}
                  onChange={handleExportOptionChange("status")}
                  searchPlaceholder="Search status"
                  disabled={isExporting}
                >
                  <option value="">All Statuses</option>
                  {masterStatusOptions.map((option) => (
                    <option
                      key={option.id || option.code || option.value}
                      value={option.code || option.value}
                    >
                      {option.label || option.value}
                    </option>
                  ))}
                </SearchableSelect>
              </div>

              <div className="export-popup__field">
                <label
                  className="export-popup__label"
                  htmlFor="view-date-export-entry-type"
                >
                  Entry Type
                </label>
                <SearchableSelect
                  id="view-date-export-entry-type"
                  className="export-popup__select"
                  value={exportOptions.entryType}
                  onChange={handleExportOptionChange("entryType")}
                  searchPlaceholder="Search entry type"
                  disabled={isExporting}
                >
                  <option value="">All Entry Types</option>
                  {entryTypes.map((option) => (
                    <option key={option.code} value={option.code}>
                      {getEntryTypeLabel(option, selectedLanguage)}
                    </option>
                  ))}
                </SearchableSelect>
              </div>

              <div className="export-popup__field">
                <label
                  className="export-popup__label"
                  htmlFor="view-date-export-start-date"
                >
                  Start Date
                </label>
                <input
                  id="view-date-export-start-date"
                  type="date"
                  className="export-popup__input"
                  value={exportOptions.startDate}
                  onChange={handleExportOptionChange("startDate")}
                  disabled={isExporting}
                />
              </div>

              <div className="export-popup__field">
                <label
                  className="export-popup__label"
                  htmlFor="view-date-export-end-date"
                >
                  End Date
                </label>
                <input
                  id="view-date-export-end-date"
                  type="date"
                  className="export-popup__input"
                  value={exportOptions.endDate}
                  onChange={handleExportOptionChange("endDate")}
                  disabled={isExporting}
                />
              </div>
            </div>

            <div className="export-popup__actions">
              <button
                type="button"
                className="export-popup__secondary-btn"
                onClick={() =>
                  setExportOptions({
                    ...INITIAL_EXPORT_OPTIONS,
                    lang: selectedLanguage,
                  })
                }
                disabled={isExporting}
              >
                Reset Filters
              </button>
              <button
                type="button"
                className="export-popup__primary-btn"
                onClick={exportCasePropertyData}
                disabled={isExporting}
              >
                {isExporting ? "Exporting..." : "Download"}
              </button>
            </div>
          </div>
        </div>
      )}
      {showPopup && (
        <div className="data-view-popup">
          <DataView
            data={selectedData}
            qrCodeUrl={`${API_URL}/api/data/${selectedData.id}/qr`}
            onClose={handleClosePopup}
          />
        </div>
      )}
      {showEditForm && selectedData && (
        <div
          className="insert-data-popup new_data-form-popup new_data-form-popup--edit"
          ref={insertRef}
        >
          <div className="popup-content data-box new_data-form-surface">
            <div className="heading-content new_data-form-heading">
              <div className="heading">Edit Data</div>
              <div className="close-icon" onClick={handleEditClose}>
                <IoMdClose />
              </div>
            </div>
            <div className="insert-popup edit-pop new_data-form-scroll">
              <div className="new_data-form-body">
                <div
                  style={{ width: "100%" }}
                  className="insert-form new_data-form-card"
                >
                  <div className="insert-form-content new_data-form-content">
                    <form
                      id="viewdate-edit-form"
                      onSubmit={handleEditSubmit}
                      className="submit new_data-form"
                    >
                      <div className="first-input-form-group new_data-form-grid">
                        {/* <div className="gunanumber form-group">
                      <label htmlFor="gunaNumberInput">
                        <span className="text-danger">*</span>
                        {translatedText("guna_number")}
                      </label>
                      <div className="input-group">
                        <input
                          type="text"
                          id="gunaNumberInput"
                          value={selectedData.guna_number}
                          className="form-control"
                          onChange={(e) =>
                            setSelectedData({
                              ...selectedData,
                              guna_number: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div> */}

                        <EntryTypeFields
                          entryTypes={entryTypes}
                          selectedEntryType={selectedData.entry_type}
                          selectedLanguage={selectedLanguage}
                          value={selectedData}
                          errors={editValidationErrors}
                          translatedText={translatedText}
                          onEntryTypeChange={handleEntryTypeChange}
                          onFieldChange={handleEntryTypeFieldChange}
                          idPrefix={`view-date-edit-${selectedData.id || "case"}`}
                        />

                        <div className=" form-group">
                          <label htmlFor="dateOfSeizureInput">
                            <span className="text-danger">*</span>
                            {translatedText("date_of_seizure")}
                          </label>
                          <div className="date-picker-container">
                            <div className="input-group">
                              <DatePicker
                                selected={
                                  new Date(selectedData.date_of_seizure)
                                }
                                className="form-control date-picker-input"
                                onChange={(date) =>
                                  setSelectedData({
                                    ...selectedData,
                                    date_of_seizure: date.toISOString(),
                                  })
                                }
                                dateFormat="dd/MM/yyyy" // Format as needed
                                id="dateOfSeizureInput"
                                showPopperArrow={false} // Optional: To hide the arrow on the date picker
                              />
                            </div>
                            <div className="input-group-append">
                              <span
                                className="input-group-text"
                                // onClick={() => handleDateIconClick(index)}
                              >
                                <FcCalendar />
                              </span>
                            </div>
                          </div>
                        </div>

                        <div className="exhibitnumber form-group">
                          <label htmlFor="exhibitNumberInput">
                            {" "}
                            <span className="text-danger">*</span>
                            {translatedText("exhibit_number")}
                          </label>
                          <div className="input-group">
                            <input
                              type="text"
                              id="exhibitNumberInput"
                              className="form-control"
                              value={selectedData.exhibit_number}
                              onChange={(e) =>
                                setSelectedData({
                                  ...selectedData,
                                  exhibit_number: e.target.value,
                                })
                              }
                              min="0"
                            />
                          </div>
                        </div>
                        {activeCasePropertyTypeOptions.length > 0 && (
                          <div className="form-group">
                            <label htmlFor="muddamaalTypeInput">
                              <span className="text-danger">*</span>
                              {translatedText("muddamaal_type")}
                            </label>
                            <div className="input-group">
                              <select
                                type="text"
                                id="muddamaalTypeInput"
                                className="form-control"
                                value={selectedData.muddamaal_type}
                                onChange={(e) =>
                                  setSelectedData({
                                    ...selectedData,
                                    muddamaal_type: e.target.value,
                                    vehicle_reason: isVehicleCasePropertyType(
                                      e.target.value,
                                      masterCasePropertyTypeOptions,
                                    )
                                      ? matchOptionValue(
                                          masterVehicleReasonOptions,
                                          selectedData.vehicle_reason,
                                        ) ||
                                        masterVehicleReasonOptions[0]?.value ||
                                        ""
                                      : "",
                                  })
                                }
                              >
                                {(activeCasePropertyTypeOptions.some(
                                  (option) =>
                                    option.value ===
                                    selectedData.muddamaal_type,
                                )
                                  ? activeCasePropertyTypeOptions
                                  : [
                                      {
                                        label: selectedData.muddamaal_type,
                                        value: selectedData.muddamaal_type,
                                      },
                                      ...activeCasePropertyTypeOptions,
                                    ].filter((option) => option?.value)
                                ).map((option, optionIndex) => (
                                  <option
                                    key={option.id || optionIndex}
                                    value={option.value}
                                  >
                                    {option.label}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        )}

                        {/* {userState === "Andaman and Nicobar" &&
                      selectedData.muddamaal_type ===
                        translatedText("other") && (
                        <div className="form-group">
                          <label htmlFor="other_case_property_name">
                            {translatedText("other_case_property")}
                          </label>
                          <div className="input-group">
                            <input
                              type="text"
                              name="other_case_property_name"
                              id="other_case_property_name"
                              placeholder={translatedText(
                                "enter_other_case_property"
                              )}
                              className="form-control"
                              value={
                                selectedData.other_case_property_name || ""
                              }
                              onChange={(e) =>
                                setSelectedData({
                                  ...selectedData,
                                  other_case_property_name: e.target.value,
                                })
                              }
                              min="0"
                            />
                          </div>
                        </div>
                      )} */}

                        {(userState === "Andaman and Nicobar" ||
                          userState === "Maharashtra") &&
                          isOtherCasePropertyType(
                            selectedData.muddamaal_type,
                            masterCasePropertyTypeOptions,
                          ) && (
                            <div className="form-group">
                              <label htmlFor="other_case_property_name">
                                {translatedText("other_case_property")}
                              </label>
                              <div className="input-group">
                                <input
                                  type="text"
                                  name="other_case_property_name"
                                  id="other_case_property_name"
                                  placeholder={translatedText(
                                    "enter_other_case_property",
                                  )}
                                  className="form-control"
                                  value={
                                    selectedData.other_case_property_name || ""
                                  }
                                  onChange={(e) =>
                                    setSelectedData({
                                      ...selectedData,
                                      other_case_property_name: e.target.value,
                                    })
                                  }
                                  min="0"
                                />
                              </div>
                            </div>
                          )}

                        {isVehicleCasePropertyType(
                          selectedData.muddamaal_type,
                          masterCasePropertyTypeOptions,
                        ) && (
                          <div className="form-group">
                            <label htmlFor="vehicleReasonInput">
                              <span className="text-danger">*</span>
                              {translatedText(
                                "reason_for_impounding_the_vehicle",
                              )}
                            </label>
                            <div className="input-group">
                              <select
                                type="text"
                                id="vehicleReasonInput"
                                className="form-control"
                                value={selectedData.vehicle_reason}
                                onChange={(e) =>
                                  setSelectedData({
                                    ...selectedData,
                                    vehicle_reason: e.target.value,
                                  })
                                }
                              >
                                {(masterVehicleReasonOptions.length > 0
                                  ? masterVehicleReasonOptions
                                  : selectedData.vehicle_reason
                                    ? [
                                        {
                                          label: selectedData.vehicle_reason,
                                          value: selectedData.vehicle_reason,
                                        },
                                      ]
                                    : []
                                ).map((option, optionIndex) => (
                                  <option
                                    key={option.id || optionIndex}
                                    value={option.value}
                                  >
                                    {option.label}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        )}

                        {/* Charge Sheet Date */}
                        <div className="form-group">
                          <label htmlFor="chargeSheetDateInput">
                            <span className="text-danger">*</span>
                            {translatedText("chart_sheet_date")}
                          </label>
                          <div className="date-picker-container">
                            <div className="input-group">
                              <DatePicker
                                selected={
                                  selectedData.chart_sheet_date
                                    ? new Date(selectedData.chart_sheet_date)
                                    : null // Show placeholder if null
                                }
                                onChange={(date) =>
                                  setSelectedData((prevData) => ({
                                    ...prevData,
                                    chart_sheet_date: date
                                      ? date.toISOString()
                                      : null,
                                  }))
                                }
                                dateFormat="dd/MM/yyyy"
                                placeholderText={translatedText(
                                  "enter_chart_sheet_date",
                                )}
                                isClearable
                                id="chargeSheetDateInput"
                                showPopperArrow={false}
                                className="form-control date-picker-input"
                              />
                            </div>
                            <div className="input-group-append">
                              <span className="input-group-text">
                                <FcCalendar />
                              </span>
                            </div>
                          </div>
                        </div>

                        <div className="form-group">
                          <label htmlFor="nextCourtDateInput">
                            <span className="text-danger">*</span>
                            {translatedText("next_court_date")}
                          </label>
                          <div className="date-picker-container">
                            <div className="input-group">
                              <DatePicker
                                selected={
                                  selectedData.next_court_date
                                    ? new Date(selectedData.next_court_date)
                                    : null // Show placeholder if null
                                }
                                onChange={(date) =>
                                  setSelectedData((prevData) => ({
                                    ...prevData,
                                    next_court_date: date
                                      ? date.toISOString()
                                      : null,
                                  }))
                                }
                                dateFormat="dd/MM/yyyy"
                                placeholderText={translatedText(
                                  "enter_next_court_date",
                                )}
                                isClearable
                                id="nextCourtDateInput"
                                showPopperArrow={false}
                                className="form-control date-picker-input"
                              />
                            </div>
                            <div className="input-group-append">
                              <span className="input-group-text">
                                <FcCalendar />
                              </span>
                            </div>
                          </div>
                        </div>

                        <div className="form-group">
                          <label htmlFor="unit">{translatedText("unit")}</label>
                          <br />
                          <div className="input-group">
                            <select
                              id="unit"
                              name="unit"
                              className="form-control"
                              value={selectedUnit}
                              onChange={handleUnitChange}
                            >
                              <option value="">
                                {translatedText("select_unit")}
                              </option>
                              {(masterUnitOptions.length > 0
                                ? masterUnitOptions
                                : selectedUnit
                                  ? [
                                      {
                                        label: selectedUnit,
                                        value: selectedUnit,
                                      },
                                    ]
                                  : []
                              ).map((option) => (
                                <option key={option.value} value={option.value}>
                                  {option.label}
                                </option>
                              ))}
                            </select>
                            <div className="input-group-append">
                              <span className="input-group-text">
                                <MdExpandMore />
                              </span>
                            </div>
                          </div>
                        </div>

                        <div className="quantity form-group">
                          <label htmlFor="quantityInput">
                            {translatedText("quantity")}
                          </label>
                          <div className="input-group">
                            <input
                              type="number"
                              id="quantityInput"
                              className="form-control"
                              value={selectedData.quantity}
                              onChange={(e) =>
                                setSelectedData({
                                  ...selectedData,
                                  quantity: e.target.value,
                                })
                              }
                              min="0"
                            />
                          </div>
                        </div>
                        <div className="price form-group">
                          <label htmlFor="priceInput">
                            {translatedText("price")}
                          </label>
                          <div className="input-group">
                            <input
                              type="price"
                              id="priceInput"
                              className="form-control"
                              value={selectedData.price}
                              onChange={(e) =>
                                setSelectedData({
                                  ...selectedData,
                                  price: e.target.value,
                                })
                              }
                              min="0"
                            />
                          </div>
                        </div>
                        <div className="description-group form-group">
                          <label htmlFor="descriptionInput">
                            {translatedText("description")}
                          </label>
                          <div className="input-group">
                            <textarea
                              type="textarea"
                              id="descriptionInput"
                              className="form-control desc-txt"
                              value={selectedData.description}
                              onChange={(e) =>
                                setSelectedData({
                                  ...selectedData,
                                  description: e.target.value,
                                })
                              }
                            />
                            <small className="word-count">
                              {countWords(selectedData.description)} words
                            </small>
                          </div>
                        </div>
                      </div>

                      {/* <div className="middle-input-form-group">
                    <div className="acts-group">
                      <div className="form-group">
                        <label htmlFor="selectedOptions">Acts</label>
                        <Multiselect
                          options={options}
                          selectedValues={selectedOptions}
                          onSelect={handleSelect}
                          onRemove={handleRemove}
                          displayValue="name"
                          style={{
                            chips: {
                              background: "#007bff",
                              color: "#fff",
                              fontSize: "14px",
                            },
                            searchBox: { border: "1px solid #D9E1FF" },
                            optionContainer: {
                              border: "1px solid #007bff",
                              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                            },
                          }}
                          placeholder="Select options"
                          closeIcon="cancel"
                          avoidHighlightFirstOption={true}
                          showCheckbox={true}
                          hidePlaceholder={false}
                          closeOnSelect={false}
                        />
                      </div>
                    </div>
                    {selectedOptions.some(
                      (option) => option.name === "Others Acts"
                    ) && (
                        <div className="form-group">
                          <label htmlFor="specifyAct">Specify Act</label>
                          <input
                            type="text"
                            name="specifyAct"
                            id="specifyAct"
                            className="form-control"
                            value={specifyAct}
                            onChange={(e) => setSpecifyAct(e.target.value)}
                            placeholder="Specify act"
                          />
                        </div>
                      )}
                    <div className="sub-middle-input-form-group">
                      {selectedOptions.map((option) => (
                        <div key={option.id} className="form-group">
                          <label htmlFor={option.name}>{option.name}</label>
                          <input
                            type="text"
                            name={option.name}
                            id={option.name}
                            className="form-control"
                            value={sectionOfLaws[option.name] || ""}
                            onChange={(e) =>
                              handleSectionOfLawChange(e, option.name)
                            }
                            placeholder={`Section of law for ${option.name}`}
                          />
                        </div>
                      ))}
                    </div>
                  </div> */}

                      <div className="middle-input-form-group new_data-form-section">
                        <div className="acts-group">
                          <div className="form-group">
                            <label htmlFor="selectedOptions">
                              {translatedText("act")}
                            </label>
                            <Multiselect
                              // options={options}
                              options={filteredOptions}
                              selectedValues={selectedOptions}
                              onSelect={handleSelect}
                              onRemove={handleRemove}
                              displayValue="name"
                              style={{
                                chips: {
                                  background: "#007bff",
                                  color: "#fff",
                                  fontSize: "14px",
                                },
                                searchBox: { border: "1px solid #D9E1FF" },
                                optionContainer: {
                                  border: "1px solid #007bff",
                                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                },
                              }}
                              placeholder={translatedText("select_option")}
                              closeIcon="cancel"
                              avoidHighlightFirstOption={true}
                              showCheckbox={true}
                              hidePlaceholder={false}
                              closeOnSelect={false}
                            />
                          </div>
                        </div>

                        <div className="sub-middle-input-form-group new_data-form-subgrid">
                          {selectedOptions.map(
                            (option) =>
                              !isOtherActOption(option) && (
                                <div key={option.id} className="form-group">
                                  <label htmlFor={option.name}>
                                    {option.name}
                                  </label>
                                  <input
                                    type="text"
                                    name={option.name}
                                    id={option.name}
                                    className="form-control"
                                    value={getSectionOfLawValue(option.name)}
                                    onChange={(e) =>
                                      handleSectionOfLawChange(e, option.name)
                                    }
                                    placeholder={`Section of law for ${option.name}`}
                                  />
                                </div>
                              ),
                          )}

                          {selectedOptions.some((option) =>
                            isOtherActOption(option),
                          ) && (
                            <div className="other-acts-group new_data-form-subgrid">
                              <div className="form-group">
                                <label htmlFor="specifyAct">Specify Act</label>
                                <input
                                  type="text"
                                  name="specifyAct"
                                  id="specifyAct"
                                  className="form-control"
                                  value={specifyAct}
                                  onChange={(e) =>
                                    setSpecifyAct(e.target.value)
                                  }
                                  placeholder="Specify act"
                                />
                              </div>
                              <div className="form-group">
                                <label htmlFor={otherActOptionName}>
                                  {otherActOptionName}
                                </label>
                                <input
                                  type="text"
                                  name={otherActOptionName}
                                  id={otherActOptionName}
                                  className="form-control"
                                  value={getSectionOfLawValue(
                                    otherActOptionName,
                                    {
                                      isOther: true,
                                    },
                                  )}
                                  onChange={(e) =>
                                    handleSectionOfLawChange(
                                      e,
                                      otherActOptionName,
                                    )
                                  }
                                  placeholder={`Section of law for ${otherActOptionName}`}
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div className="last-button new_data-form-footer">
              <div className="last-group new_data-form-actions">
                <button
                  type="button"
                  className="case-property-button new_data-status-trigger"
                  onClick={() => {
                    setShowCasePropertyPopup(true);
                    setShowEditForm(false);
                  }}
                >
                  Update Status of Case Property
                </button>
                <button
                  type="button"
                  className="btn close-button"
                  onClick={() => setShowEditForm(false)}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  form="viewdate-edit-form"
                  className="btn save-button"
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showCasePropertyPopup && selectedData && (
        <div className="update-input-form-groups">
          <div className="update-input-group-contants">
            <div className="update-popup-heading">
              <div className="update-popup-heading-content">
                Update Case Property
              </div>
              <div
                className="update-popup-heading-content close-icons"
                onClick={closeUpdateButton}
              >
                <IoMdClose className="update-icon" />
              </div>
            </div>
            <div className="update-popup-header-separator"></div>
            <div className="update-popup-body">
              <form>
                <div className="form-group">
                  <label htmlFor="statusOfMuddamaalInput">
                    {translatedText("status_of_muddamaal")}
                  </label>
                  <div className="input-group">
                    <select
                      type="text"
                      id="statusOfMuddamaalInput"
                      className="form-control"
                      value={selectedData.status_of_muddamaal}
                      onChange={(e) =>
                        setSelectedData({
                          ...selectedData,
                          status_of_muddamaal: e.target.value,
                        })
                      }
                    >
                      {(masterStatusOptions.length > 0
                        ? masterStatusOptions
                        : selectedData.status_of_muddamaal
                          ? [
                              {
                                label: selectedData.status_of_muddamaal,
                                value: selectedData.status_of_muddamaal,
                              },
                            ]
                          : []
                      ).map((option, optionIndex) => (
                        <option
                          key={option.id || optionIndex}
                          value={option.value}
                        >
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                {translatedText("destroyed_disposed") ===
                selectedData.status_of_muddamaal ? (
                  <>
                    <div className="form-group">
                      <label htmlFor="disposalOnCourt">
                        {translatedText("disposal_on_court_order")}
                      </label>
                      <br />
                      <div className="input-group">
                        <select
                          id="disposalOnCourt"
                          value={selectedCourtOrderOption}
                          onChange={handleDropdownCourtOrderChange}
                          className="form-control"
                        >
                          <option value="Disposed">Disposed</option>
                          <option value="Auction">Auction</option>
                        </select>
                      </div>
                    </div>

                    {selectedCourtOrderOption === "Disposed" && (
                      <>
                        <div className="form-group">
                          <label htmlFor="executiveOrder">
                            {translatedText("order_no_for_deputed")}
                          </label>

                          <input
                            type="number"
                            name="executiveOrder"
                            id="executiveOrder"
                            className="form-control"
                            value={sectionExecutiveOrderNo}
                            onChange={(e) =>
                              setSectionExecutiveOrderNo(e.target.value)
                            }
                            placeholder={translatedText(
                              "enter_order_no_deputed",
                            )}
                          />
                        </div>
                        <div className="form-group">
                          <label htmlFor="disposalDate">
                            {translatedText("date_of_disposal")}
                          </label>

                          <input
                            type="date"
                            name="disposalDate"
                            id="disposalDate"
                            className="form-control"
                            value={sectionDisposaldate}
                            onChange={(e) =>
                              setSectionsectionDisposaldate(e.target.value)
                            }
                          />
                        </div>
                        <div className="form-group-attachment attach-new">
                          <label htmlFor="Attachment">
                            Attachment for disposal order
                          </label>
                          <div className="input-group-attachment">
                            <button
                              type="button"
                              className="challan-button"
                              onClick={handleUploadButtonClick}
                            >
                              <FiUpload /> Upload File
                            </button>
                            <input
                              type="file"
                              ref={fileInputRef}
                              style={{ display: "none" }}
                              onChange={handleDisposalFileInputChange}
                            />
                            {selectedFiles.length > 0 && ( // Conditionally render if files are selected
                              <span
                                className="inquiry-file-btn"
                                onClick={handleIconClick}
                              >
                                <MdAttachFile className="inquiry-file-icon" />{" "}
                                {`${selectedFiles.length}`}
                              </span>
                            )}
                            {isPopupOpens && (
                              <div className="attach-popups">
                                <div className="attach-popup-contant">
                                  <div className="attachment-header">
                                    <div className="attachment-header-content">
                                      Attachments
                                    </div>
                                    <button
                                      className="fiile-close-btn"
                                      onClick={handleCloseAttachment}
                                    >
                                      <IoCloseOutline className="file-close-icon" />
                                    </button>
                                  </div>
                                  {selectedFiles.length > 0 && (
                                    <div className="attach-scrroll-body">
                                      {selectedFiles.map((file, index) => (
                                        <div
                                          className="attach-popup-contant-body"
                                          key={index}
                                        >
                                          <div className="attach-file-container">
                                            <div className="attach-file-show">
                                              <div className="text-attachment">
                                                {file.name.length > 15
                                                  ? `${file.name.substring(
                                                      0,
                                                      15,
                                                    )}...`
                                                  : file.name}
                                              </div>
                                              <div className="text-attachment-file">
                                                File Size:(
                                                {(file.size / 1024).toFixed(
                                                  2,
                                                )}{" "}
                                                KB)
                                              </div>
                                            </div>
                                            <div
                                              className="file-delete-btn"
                                              onClick={() =>
                                                handleDeleteFile(index)
                                              }
                                            >
                                              <span>
                                                {" "}
                                                <MdDeleteOutline className="file-delete-icon" />
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </>
                    )}
                    {selectedCourtOrderOption === "Auction" && (
                      <>
                        <div className="form-group">
                          <label htmlFor="auctionDate">
                            {translatedText("date_of_auction")}
                          </label>
                          <input
                            type="date"
                            name="auctionDate"
                            id="auctionDate"
                            className="form-control"
                            value={sectionAuctionDate}
                            onChange={(e) =>
                              setSectionAuctionDate(e.target.value)
                            }
                          />
                        </div>
                        <div className="form-group">
                          <label htmlFor="auctionOrderNo">
                            {translatedText("auction_order_no")}
                          </label>
                          <input
                            type="number"
                            name="auctionOrderNo"
                            id="auctionOrderNo"
                            className="form-control"
                            value={sectionAuctionOrderNo}
                            onChange={(e) =>
                              setSectionAuctionOrderNo(e.target.value)
                            }
                            placeholder={translatedText(
                              "enter_auction_order_no",
                            )}
                          />
                        </div>

                        <div className="form-group">
                          <label htmlFor="awarded">
                            {translatedText("awarded_to_whom")}
                          </label>
                          <input
                            type="text"
                            name="awarded"
                            id="awarded"
                            className="form-control"
                            value={sectionAawarded}
                            onChange={(e) => setSectionAawarded(e.target.value)}
                            placeholder={translatedText(
                              "enter_awarded_recipient",
                            )}
                          />
                        </div>
                        <div className="form-group">
                          <label htmlFor="paymentMode">
                            {translatedText("payment_made_through")}
                          </label>
                          <div className="radio-input-option pmt-radio">
                            <div className="radio-input">
                              <input
                                type="radio"
                                id="bankDeposit"
                                name="paymentMethod"
                                className="form-group-controls"
                                value="Bank Deposit"
                                onChange={(e) =>
                                  setSelectedPaymentMode(e.target.value)
                                }
                              />
                              <label htmlFor="bankDeposit">
                                {translatedText("bank_deposit")}
                              </label>
                            </div>
                            <div className="radio-input">
                              <input
                                type="radio"
                                id="cheque"
                                name="paymentMethod"
                                value="Cheque"
                                onChange={(e) =>
                                  setSelectedPaymentMode(e.target.value)
                                }
                              />
                              <label htmlFor="cheque">
                                {translatedText("cheque")}
                              </label>
                            </div>
                            <div className="radio-input">
                              <input
                                type="radio"
                                id="challan"
                                name="paymentMethod"
                                value="Challan"
                                onChange={(e) =>
                                  setSelectedPaymentMode(e.target.value)
                                }
                              />
                              <label htmlFor="challan">
                                {translatedText("challan")}
                              </label>
                            </div>
                          </div>
                        </div>

                        <div className="form-group">
                          <label htmlFor="auctionMemoNo">
                            {translatedText("handover_memo_no")}
                          </label>
                          <input
                            type="number"
                            name="auctionMemoNo"
                            id="auctionMemoNo"
                            className="form-control"
                            value={sectionAuctionMemoNo}
                            onChange={(e) =>
                              setSectionAuctionMemoNo(e.target.value)
                            }
                            placeholder={translatedText(
                              "enter_handover_memo_no",
                            )}
                          />
                        </div>
                        <div className="form-group-attachment attach-new">
                          <label htmlFor="Attachment">
                            Attachment for auction order
                          </label>
                          <div className="input-group-attachment">
                            <button
                              type="button"
                              className="challan-button"
                              onClick={handleUploadButtonClick}
                            >
                              <FiUpload /> Upload File
                            </button>
                            <input
                              type="file"
                              ref={fileInputRef}
                              style={{ display: "none" }}
                              onChange={handleAuctionFileInputChange}
                            />
                            {selectedFiles.length > 0 && ( // Conditionally render if files are selected
                              <span
                                className="inquiry-file-btn"
                                onClick={handleIconClick}
                              >
                                <MdAttachFile className="inquiry-file-icon" />{" "}
                                {`${selectedFiles.length}`}
                              </span>
                            )}
                            {isPopupOpens && (
                              <div className="attach-popups">
                                <div className="attach-popup-contant">
                                  <div className="attachment-header">
                                    <div className="attachment-header-content">
                                      Attachments
                                    </div>
                                    <button
                                      className="fiile-close-btn"
                                      onClick={handleCloseAttachment}
                                    >
                                      <IoCloseOutline className="file-close-icon" />
                                    </button>
                                  </div>
                                  {selectedFiles.length > 0 && (
                                    <div className="attach-scrroll-body">
                                      {selectedFiles.map((file, index) => (
                                        <div
                                          className="attach-popup-contant-body"
                                          key={index}
                                        >
                                          <div className="attach-file-container">
                                            <div className="attach-file-show">
                                              <div className="text-attachment">
                                                {file.name.length > 15
                                                  ? `${file.name.substring(
                                                      0,
                                                      15,
                                                    )}...`
                                                  : file.name}
                                              </div>
                                              <div className="text-attachment-file">
                                                File Size:(
                                                {(file.size / 1024).toFixed(
                                                  2,
                                                )}{" "}
                                                KB)
                                              </div>
                                            </div>
                                            <div
                                              className="file-delete-btn"
                                              onClick={() =>
                                                handleDeleteFile(index)
                                              }
                                            >
                                              <span>
                                                {" "}
                                                <MdDeleteOutline className="file-delete-icon" />
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </>
                    )}
                  </>
                ) : null}

                {translatedText("other") ===
                selectedData.status_of_muddamaal ? (
                  <>
                    <div className="form-group">
                      <label htmlFor="other_status_case_property">
                        {translatedText("other_status_case_property")}
                      </label>
                      <br />
                      <div className="input-group">
                        <input
                          type="text"
                          name="other_status_case_property"
                          id="other_status_case_property"
                          className="form-control"
                          value={sectionOtherStatus}
                          onChange={(e) =>
                            setSectionOtherStatus(e.target.value)
                          }
                          placeholder={translatedText(
                            "enter_other_status_case_property",
                          )}
                        />
                      </div>
                    </div>
                  </>
                ) : null}

                {translatedText("sent_to_ps_ccs") ===
                selectedData.status_of_muddamaal ? (
                  <>
                    <div className="form-group">
                      <label htmlFor="sentBy">
                        {translatedText("sent_by")}
                      </label>
                      <br />
                      <div className="input-group">
                        <input
                          type="text"
                          name="sentBy"
                          id="sentBy"
                          className="form-control"
                          value={sectionSentBy}
                          onChange={(e) => setSectionSentBy(e.target.value)}
                          placeholder={translatedText("enter_sent_by")}
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label htmlFor="Date_Status">
                        {translatedText("Date")}
                      </label>
                      <br />
                      <div className="input-group">
                        <input
                          type="date"
                          id="bankTrans"
                          name="bankTrans"
                          className="form-control"
                          ng-model="orderAstro.paymentDate"
                          onChange={(e) =>
                            setSelectedData({
                              ...selectedData,
                              date_status: e.target.value,
                            })
                          }
                          ng-disabled="isDisabled"
                          required
                        />
                      </div>
                    </div>
                  </>
                ) : null}

                {translatedText("central_cold_storage") ===
                selectedData.status_of_muddamaal ? (
                  <>
                    <div className="form-group">
                      <label htmlFor="sentBy">
                        {translatedText("sent_by")}
                      </label>
                      <br />
                      <div className="input-group">
                        <input
                          type="text"
                          name="sentBy"
                          id="sentBy"
                          className="form-control"
                          value={sectionSentBy}
                          onChange={(e) => setSectionSentBy(e.target.value)}
                          placeholder={translatedText("enter_sent_by")}
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label htmlFor="Date_Status">
                        {translatedText("Date")}
                      </label>
                      <br />
                      <div className="input-group">
                        <input
                          type="date"
                          id="bankTrans"
                          name="bankTrans"
                          className="form-control"
                          ng-model="orderAstro.paymentDate"
                          onChange={(e) =>
                            setSelectedData({
                              ...selectedData,
                              date_status: e.target.value,
                            })
                          }
                          ng-disabled="isDisabled"
                          required
                        />
                      </div>
                    </div>
                  </>
                ) : null}

                {translatedText("release_on_court_order") ===
                selectedData.status_of_muddamaal ? (
                  <>
                    <div className="form-group">
                      <label htmlFor="courtOrderNo">
                        {translatedText("court_order_no")}
                      </label>
                      <br />
                      <div className="input-group">
                        <input
                          type="number"
                          name="CourtOrderNo"
                          id="CourtOrderNo"
                          className="form-control"
                          value={sectionCourtOrderNo}
                          onChange={(e) =>
                            setSectionCourtOrderNo(e.target.value)
                          }
                          placeholder={translatedText("enter_court_order_no")}
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label htmlFor="releasedToWhom">
                        {translatedText("released_to_whom")}
                      </label>
                      <br />
                      <div className="input-group">
                        <input
                          type="text"
                          name="ReleasedToWhom"
                          id="ReleasedToWhom"
                          className="form-control"
                          value={sectionReleased}
                          onChange={(e) => setSectionReleased(e.target.value)}
                          placeholder={translatedText("enter_releaser_name")}
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label htmlFor="releseddate">
                        {translatedText("date_of_release")}
                      </label>
                      <br />
                      <div className="input-group">
                        <input
                          type="date"
                          name="Releseddate"
                          id="Releseddate"
                          className="form-control"
                          value={sectionRelesedDate}
                          onChange={(e) =>
                            setSectionRelesedDate(e.target.value)
                          }
                          placeholder={translatedText("enter_date_of_release")}
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label htmlFor="gdNo">
                        {translatedText("gd_entry_no")}
                      </label>
                      <br />
                      <div className="input-group">
                        <input
                          type="number"
                          name="GdNo"
                          id="GdNo"
                          className="form-control"
                          value={sectionGdNo}
                          onChange={(e) => setSectionGdNo(e.target.value)}
                          placeholder={translatedText("enter_gd_entry_no")}
                        />
                      </div>
                    </div>
                    <div className="form-group-attachment attach-new">
                      <label htmlFor="Attachment">
                        Attachment for release on court order
                      </label>
                      <div className="input-group-attachment">
                        <button
                          type="button"
                          className="challan-button"
                          onClick={handleUploadButtonClick}
                        >
                          <FiUpload /> Upload File
                        </button>
                        <input
                          type="file"
                          ref={fileInputRef}
                          style={{ display: "none" }}
                          onChange={handleCourtOrderFileInputChange}
                        />
                        {selectedFiles.length > 0 && ( // Conditionally render if files are selected
                          <span
                            className="inquiry-file-btn"
                            onClick={handleIconClick}
                          >
                            <MdAttachFile className="inquiry-file-icon" />{" "}
                            {`${selectedFiles.length}`}
                          </span>
                        )}
                        {isPopupOpens && (
                          <div className="attach-popups">
                            <div className="attach-popup-contant">
                              <div className="attachment-header">
                                <div className="attachment-header-content">
                                  Attachments
                                </div>
                                <button
                                  className="fiile-close-btn"
                                  onClick={handleCloseAttachment}
                                >
                                  <IoCloseOutline className="file-close-icon" />
                                </button>
                              </div>
                              {selectedFiles.length > 0 && (
                                <div className="attach-scrroll-body">
                                  {selectedFiles.map((file, index) => (
                                    <div
                                      className="attach-popup-contant-body"
                                      key={index}
                                    >
                                      <div className="attach-file-container">
                                        <div className="attach-file-show">
                                          <div className="text-attachment">
                                            {file.name.length > 15
                                              ? `${file.name.substring(
                                                  0,
                                                  15,
                                                )}...`
                                              : file.name}
                                          </div>
                                          <div className="text-attachment-file">
                                            File Size:(
                                            {(file.size / 1024).toFixed(2)} KB)
                                          </div>
                                        </div>
                                        <div
                                          className="file-delete-btn"
                                          onClick={() =>
                                            handleDeleteFile(index)
                                          }
                                        >
                                          <span>
                                            {" "}
                                            <MdDeleteOutline className="file-delete-icon" />
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                ) : null}

                {translatedText("comes_from_fsl") ===
                  selectedData.status_of_muddamaal ||
                translatedText("released_in_fsl") ===
                  selectedData.status_of_muddamaal ? (
                  <>
                    <div className="form-group">
                      <label htmlFor="fslList">FSL List</label>
                      <br />
                      <div className="input-group">
                        <select
                          id="fslList"
                          value={selectedData.fslList}
                          className="form-control"
                          onChange={(e) =>
                            setSelectedData({
                              ...selectedData,
                              fslList: e.target.value,
                            })
                          }
                        >
                          <option value="FSL Port Blair">FSL Port Blair</option>
                          {userState === "Goa" && (
                            <option value="FSL Verna">FSL Verna</option>
                          )}
                          <option value="CFSL Pune">CFSL Pune</option>
                          <option value="CFSL Kolkata">CFSL Kolkata</option>
                          <option value="CFSL Chandigarh">
                            CFSL Chandigarh
                          </option>
                          <option value="CFSL Hyderabad">CFSL Hyderabad</option>
                          <option value="CFSL Bhopal">CFSL Bhopal</option>
                          <option value="CFSL Assam">CFSL Assam</option>
                          <option value="CFSL Ahmedabad">CFSL Ahmedabad</option>
                          <option value="CFSL Gandhinagar">
                            CFSL Gandhinagar
                          </option>
                          <option value="Other">Other</option>
                        </select>
                      </div>
                    </div>

                    {selectedData.fslList === "Other" && (
                      <div className="form-group">
                        <label htmlFor="cfslName">
                          {translatedText("name_of_cfsl")}
                        </label>
                        <br />
                        <input
                          type="text"
                          id="cfslName"
                          // value={cfslName}
                          value={sectionCfslName}
                          className="form-control"
                          // onChange={handleCfslNameChange}
                          onChange={(e) => setSectionCfslName(e.target.value)}
                          placeholder={translatedText("enter_name_of_cfsl")}
                        />
                      </div>
                    )}

                    {selectedData.fslList === "All CFSL" && (
                      <div className="form-group">
                        <label htmlFor="cfslName">
                          {translatedText("name_of_cfsl")}
                        </label>
                        <br />
                        <input
                          type="text"
                          id="cfslName"
                          className="form-control"
                          value={sectionCfslName}
                          onChange={(e) => setSectionCfslName(e.target.value)}
                          placeholder={translatedText("enter_name_of_cfsl")}
                        />
                      </div>
                    )}
                  </>
                ) : null}

                {translatedText("handed_over_to_other_department") ===
                selectedData.status_of_muddamaal ? (
                  <>
                    <div className="form-group">
                      <label htmlFor="MemoNo">
                        {translatedText("handover_memo_no")}
                      </label>
                      <br />
                      <div className="input-group">
                        <input
                          type="number"
                          name="MemoNo"
                          id="MemoNo"
                          className="form-control"
                          value={sectionMemoNo}
                          onChange={(e) => setSectionMemoNo(e.target.value)}
                          placeholder={translatedText("enter_handover_memo_no")}
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label htmlFor="DateOfHandingOver">
                        {translatedText("date_of_handing_over")}
                      </label>
                      <br />
                      <div className="input-group">
                        <input
                          type="date"
                          name="DateOfHandingOver"
                          id="DateOfHandingOver"
                          className="form-control"
                          value={selectedDateOfHandingOver}
                          onChange={(e) =>
                            setSelectedDateOfHandingOver(e.target.value)
                          }
                        />
                      </div>
                    </div>
                    <div className="form-group-attachment attach-new">
                      <label htmlFor="Attachment">
                        Attachment for Handover memo
                      </label>
                      <div className="input-group-attachment">
                        <button
                          type="button"
                          className="challan-button"
                          onClick={handleUploadButtonClick}
                        >
                          <FiUpload /> Upload File
                        </button>
                        <input
                          type="file"
                          ref={fileInputRef}
                          style={{ display: "none" }}
                          onChange={handleHandedOverFileInputChange}
                        />
                        {selectedFiles.length > 0 && ( // Conditionally render if files are selected
                          <span
                            className="inquiry-file-btn"
                            onClick={handleIconClick}
                          >
                            <MdAttachFile className="inquiry-file-icon" />{" "}
                            {`${selectedFiles.length}`}
                          </span>
                        )}
                        {isPopupOpens && (
                          <div className="attach-popups">
                            <div className="attach-popup-contant">
                              <div className="attachment-header">
                                <div className="attachment-header-content">
                                  Attachments
                                </div>
                                <button
                                  className="fiile-close-btn"
                                  onClick={handleCloseAttachment}
                                >
                                  <IoCloseOutline className="file-close-icon" />
                                </button>
                              </div>
                              {selectedFiles.length > 0 && (
                                <div className="attach-scrroll-body">
                                  {selectedFiles.map((file, index) => (
                                    <div
                                      className="attach-popup-contant-body"
                                      key={index}
                                    >
                                      <div className="attach-file-container">
                                        <div className="attach-file-show">
                                          <div className="text-attachment">
                                            {file.name.length > 15
                                              ? `${file.name.substring(
                                                  0,
                                                  15,
                                                )}...`
                                              : file.name}
                                          </div>
                                          <div className="text-attachment-file">
                                            File Size:(
                                            {(file.size / 1024).toFixed(2)} KB)
                                          </div>
                                        </div>
                                        <div
                                          className="file-delete-btn"
                                          onClick={() =>
                                            handleDeleteFile(index)
                                          }
                                        >
                                          <span>
                                            {" "}
                                            <MdDeleteOutline className="file-delete-icon" />
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                ) : null}

                {translatedText("police_station_account") ===
                selectedData.status_of_muddamaal ? (
                  <>
                    <div className="name-status form-group">
                      <label htmlFor="Name_Status">
                        {translatedText("name_of_the_account_holder")}
                      </label>
                      <div className="input-group">
                        <input
                          type="text"
                          id="Name_Status"
                          name="Name_Status"
                          className="form-control"
                          value={selectedData.name}
                          placeholder={translatedText(
                            "enter_the_name_of_the_borrower_form_the_p_O_station",
                          )}
                          onChange={(e) =>
                            setSelectedData({
                              ...selectedData,
                              name_status: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>

                    <div className="date-status form-group">
                      <label htmlFor="Date_Status">
                        {translatedText("date_received_from_the_p_o_station")}
                      </label>
                      <div className="input-group">
                        <input
                          type="date"
                          id="bankTrans"
                          className="form-control"
                          name="bankTrans"
                          ng-model="orderAstro.paymentDate"
                          onChange={(e) =>
                            setSelectedData({
                              ...selectedData,
                              date_status: e.target.value,
                            })
                          }
                          ng-disabled="isDisabled"
                          required
                        />
                      </div>
                    </div>
                    {userState === "Gujarat" && (
                      <div className="order-status form-group">
                        <label htmlFor="Order_Status">
                          {translatedText("malkhana_register_no")}
                        </label>
                        <div className="input-group">
                          <input
                            type="number"
                            id="Order_Status"
                            className="form-control"
                            name="Order_Status"
                            placeholder={translatedText("enter_malkhana_nos")}
                            value={selectedData.order_no}
                            onChange={(e) =>
                              setSelectedData({
                                ...selectedData,
                                order_status: e.target.value,
                              })
                            }
                          />
                        </div>
                      </div>
                    )}
                  </>
                ) : null}

                {translatedText("comes_from_fsl") ===
                  selectedData.status_of_muddamaal ||
                translatedText("comes_from_court") ===
                  selectedData.status_of_muddamaal ||
                translatedText("comes_from_bank") ===
                  selectedData.status_of_muddamaal ? (
                  <>
                    <div className="name-status form-group">
                      <label htmlFor="Name_Status">
                        {translatedText("police_station_account") ===
                        selectedData.status_of_muddamaal
                          ? translatedText("name_of_the_account_holder")
                          : translatedText("comes_from_fsl") ===
                              selectedData.status_of_muddamaal
                            ? translatedText(
                                "name_of_the_one_to_be_taken_from_FSL",
                              )
                            : translatedText("comes_from_court") ===
                                selectedData.status_of_muddamaal
                              ? translatedText(
                                  "name_of_the_person_be_summoned_from_the_court",
                                )
                              : translatedText("comes_from_bank") ===
                                  selectedData.status_of_muddamaal
                                ? translatedText(
                                    "name_of_the_borrower_from_the_bank",
                                  )
                                : "Name"}
                      </label>
                      <div className="input-group">
                        <input
                          type="text"
                          id="Name_Status"
                          name="Name_Status"
                          className="form-control"
                          value={selectedData.name}
                          placeholder={
                            translatedText("police_station_account") ===
                            selectedData.status_of_muddamaal
                              ? translatedText(
                                  "enter_the_name_of_the_borrower_form_the_p_O_station",
                                )
                              : translatedText("comes_from_fsl") ===
                                  selectedData.status_of_muddamaal
                                ? translatedText(
                                    "enter_the_name_of_the_borrower_form_the_fsl",
                                  )
                                : translatedText("comes_from_court") ===
                                    selectedData.status_of_muddamaal
                                  ? translatedText(
                                      "enter_the_name_of_the_borrower_form_the_court",
                                    )
                                  : translatedText("comes_from_bank") ===
                                      selectedData.status_of_muddamaal
                                    ? translatedText(
                                        "enter_the_name_of_the_borrower_form_the_bank",
                                      )
                                    : "Name"
                          }
                          onChange={(e) =>
                            setSelectedData({
                              ...selectedData,
                              name_status: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>

                    <div className="date-status form-group">
                      <label htmlFor="Date_Status">
                        {translatedText("police_station_account") ===
                        selectedData.status_of_muddamaal
                          ? translatedText("date_received_from_the_p_o_station")
                          : translatedText("comes_from_fsl") ===
                              selectedData.status_of_muddamaal
                            ? translatedText("date_received_from_the_fsl")
                            : translatedText("comes_from_court") ===
                                selectedData.status_of_muddamaal
                              ? translatedText("date_received_from_the_court")
                              : translatedText("comes_from_bank") ===
                                  selectedData.status_of_muddamaal
                                ? translatedText("date_received_from_the_bank")
                                : "Name"}
                      </label>
                      <div className="input-group">
                        <input
                          type="date"
                          id="bankTrans"
                          className="form-control"
                          name="bankTrans"
                          ng-model="orderAstro.paymentDate"
                          onChange={(e) =>
                            setSelectedData({
                              ...selectedData,
                              date_status: e.target.value,
                            })
                          }
                          ng-disabled="isDisabled"
                          required
                        />
                      </div>
                    </div>

                    <div className="order-status form-group">
                      <label htmlFor="Order_Status">
                        {translatedText("order_no")}
                      </label>
                      <div className="input-group">
                        <input
                          type="text"
                          id="Order_Status"
                          className="form-control"
                          name="Order_Status"
                          value={selectedData.order_no}
                          placeholder={translatedText("enter_order_no")}
                          onChange={(e) =>
                            setSelectedData({
                              ...selectedData,
                              order_status: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>
                  </>
                ) : null}

                {translatedText("returned") ===
                  selectedData.status_of_muddamaal ||
                translatedText("released_in_fsl") ===
                  selectedData.status_of_muddamaal ||
                translatedText("pending_in_court") ===
                  selectedData.status_of_muddamaal ||
                translatedText("deposited_in_bank") ===
                  selectedData.status_of_muddamaal ? (
                  <>
                    <div className="name-status form-group">
                      <label htmlFor="Name_Status">
                        {translatedText("returned") ===
                        selectedData.status_of_muddamaal
                          ? translatedText("name_of_the_returen")
                          : translatedText("released_in_fsl") ===
                              selectedData.status_of_muddamaal
                            ? translatedText("name_of_the_sender_in_fsl")
                            : translatedText("pending_in_court") ===
                                selectedData.status_of_muddamaal
                              ? translatedText(
                                  "name_of_the_depositing_in_court",
                                )
                              : translatedText("deposited_in_bank") ===
                                  selectedData.status_of_muddamaal
                                ? translatedText(
                                    "name_of_the_depositing_in_bank",
                                  )
                                : "Name"}
                      </label>
                      <div className="input-group">
                        <input
                          type="text"
                          id="Name_Status"
                          name="Name_Status"
                          className="form-control"
                          value={selectedData.name}
                          placeholder={
                            translatedText("returned") ===
                            selectedData.status_of_muddamaal
                              ? translatedText("enter_the_name_of_the_returnee")
                              : translatedText("released_in_fsl") ===
                                  selectedData.status_of_muddamaal
                                ? translatedText("enter_the_name_of_the_sender")
                                : translatedText("pending_in_court") ===
                                    selectedData.status_of_muddamaal
                                  ? translatedText(
                                      "enter_the_name_of_the_submiter_person_court",
                                    )
                                  : translatedText("deposited_in_bank") ===
                                      selectedData.status_of_muddamaal
                                    ? translatedText(
                                        "enter_the_name_of_the_submiter_person_bank",
                                      )
                                    : "Name"
                          }
                          onChange={(e) =>
                            setSelectedData({
                              ...selectedData,
                              name_status: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>

                    <div className="date-status form-group">
                      <label htmlFor="Date_Status">
                        {translatedText("returned") ===
                        selectedData.status_of_muddamaal
                          ? translatedText("return_date")
                          : translatedText("released_in_fsl") ===
                              selectedData.status_of_muddamaal
                            ? translatedText("date_deposite_in_the_fsl")
                            : translatedText("pending_in_court") ===
                                selectedData.status_of_muddamaal
                              ? translatedText("date_deposite_in_the_court")
                              : translatedText("deposited_in_bank") ===
                                  selectedData.status_of_muddamaal
                                ? translatedText("date_deposite_in_the_bank")
                                : "Name"}
                      </label>
                      <div className="input-group">
                        <input
                          type="date"
                          id="bankTrans"
                          name="bankTrans"
                          className="form-control"
                          ng-model="orderAstro.paymentDate"
                          onChange={(e) =>
                            setSelectedData({
                              ...selectedData,
                              date_status: e.target.value,
                            })
                          }
                          ng-disabled="isDisabled"
                          required
                        />
                      </div>
                    </div>

                    <div className="send-status form-group">
                      <label htmlFor="Send_Status">
                        {translatedText("order_no")}
                      </label>
                      <div className="input-group">
                        <input
                          type="text"
                          id="Send_Status"
                          name="Send_Status"
                          className="form-control"
                          value={selectedData.javak_no}
                          placeholder={translatedText("enter_order_no")}
                          onChange={(e) =>
                            setSelectedData({
                              ...selectedData,
                              send_status: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>
                  </>
                ) : null}
              </form>
              <div className="last-edit-buttons">
                <button
                  type="button"
                  className="btn close-button buttons"
                  onClick={() => setShowCasePropertyPopup(false)}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  onClick={updateStatusDetails}
                  className="btn  save-button buttons"
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default DataList;
